/**
 * This file was auto-generated by @openapi-qraft/cli.
 * Do not make direct changes to the file.
 */

import type { paths } from "../schema";
import type { ServiceOperationQuery, ServiceOperationMutation } from "@openapi-qraft/react";
export interface RestService {
    /**
     * @deprecated
     * @summary Logs that a user is logged into the DMP application. No params as the token is already in the headers.
     */
    postActivityLoggingApiLogLogin: ServiceOperationMutation<{
        method: "post";
        url: "/rest/login";
    }, undefined, unknown, undefined, unknown>;
    /** @summary Logs that a user access an application and accepted the terms and conditions and privacy policies. */
    postActivityLoggingApiLogAppAccess: ServiceOperationMutation<{
        method: "post";
        url: "/rest/app-access";
    }, undefined, unknown, paths["/rest/app-access"]["post"]["parameters"], unknown>;
    /** @summary Gets a list of all applications (Authorised Roles: ProjectMember, ProjectAdministrator, ProjectLeader, PlatformAdministrator, SuperUser, ApplicationAdministrator) */
    getApplicationsApiGetApplications: ServiceOperationQuery<{
        method: "get";
        url: "/rest/applications/list";
    }, paths["/rest/applications/list"]["get"]["responses"]["200"]["content"]["text/plain"], undefined, unknown>;
    /** @summary Creates a new application (Authorised Roles: SuperUser) */
    putApplicationsApiAddApplication: ServiceOperationMutation<{
        method: "put";
        url: "/rest/applications/application";
        mediaType: "application/json-patch+json";
    }, NonNullable<paths["/rest/applications/application"]["put"]["requestBody"]>["content"]["application/json-patch+json"], paths["/rest/applications/application"]["put"]["responses"]["200"]["content"]["text/plain"], undefined, unknown>;
    /** @summary Updates an existing application (Authorised Roles: SuperUser, ApplicationAdministrator) */
    postApplicationsApiUpdateApplication: ServiceOperationMutation<{
        method: "post";
        url: "/rest/applications/application";
        mediaType: "application/json-patch+json";
    }, NonNullable<paths["/rest/applications/application"]["post"]["requestBody"]>["content"]["application/json-patch+json"], paths["/rest/applications/application"]["post"]["responses"]["200"]["content"]["text/plain"], undefined, unknown>;
    /** @summary Lists an applications current admins (Authorised Roles: SuperUser, ApplicationAdministrator) */
    getApplicationsApiListApplicationAdmins: ServiceOperationQuery<{
        method: "get";
        url: "/rest/applications/admins";
    }, paths["/rest/applications/admins"]["get"]["responses"]["200"]["content"]["text/plain"], paths["/rest/applications/admins"]["get"]["parameters"], unknown>;
    /** @summary Makes a user administrator of an application (Authorised Roles: SuperUser) */
    putApplicationsApiAddApplicationAdmin: ServiceOperationMutation<{
        method: "put";
        url: "/rest/applications/admins";
    }, undefined, paths["/rest/applications/admins"]["put"]["responses"]["200"]["content"]["text/plain"], paths["/rest/applications/admins"]["put"]["parameters"], unknown>;
    /** @summary Removes a users access to administer an application (Authorised Roles: SuperUser) */
    deleteApplicationsApiRemoveApplicationAdmin: ServiceOperationMutation<{
        method: "delete";
        url: "/rest/applications/admins";
    }, undefined, paths["/rest/applications/admins"]["delete"]["responses"]["200"]["content"]["text/plain"], paths["/rest/applications/admins"]["delete"]["parameters"], unknown>;
    /** @summary Lists any available application admins (Authorised Roles: SuperUser, ApplicationAdministrator) */
    getApplicationsApiListAllAdmins: ServiceOperationQuery<{
        method: "get";
        url: "/rest/applications/admins/all";
    }, paths["/rest/applications/admins/all"]["get"]["responses"]["200"]["content"]["text/plain"], undefined, unknown>;
    /** @summary Get a list of roles for an application (Authorised Roles: ProjectAdministrator, ProjectLeader, SuperUser, ApplicationAdministrator) */
    getApplicationsApiListApplicationRoles: ServiceOperationQuery<{
        method: "get";
        url: "/rest/applications/roles";
    }, paths["/rest/applications/roles"]["get"]["responses"]["200"]["content"]["text/plain"], paths["/rest/applications/roles"]["get"]["parameters"], unknown>;
    /** @summary Add a role for an application (Authorised Roles: SuperUser, ApplicationAdministrator) */
    putApplicationsApiAddApplicationRole: ServiceOperationMutation<{
        method: "put";
        url: "/rest/applications/roles";
        mediaType: "application/json-patch+json";
    }, NonNullable<paths["/rest/applications/roles"]["put"]["requestBody"]>["content"]["application/json-patch+json"], paths["/rest/applications/roles"]["put"]["responses"]["200"]["content"]["text/plain"], undefined, unknown>;
    /** @summary Update a role for an application (Authorised Roles: SuperUser, ApplicationAdministrator) */
    postApplicationsApiUpdateApplicationRole: ServiceOperationMutation<{
        method: "post";
        url: "/rest/applications/roles";
        mediaType: "application/json-patch+json";
    }, NonNullable<paths["/rest/applications/roles"]["post"]["requestBody"]>["content"]["application/json-patch+json"], paths["/rest/applications/roles"]["post"]["responses"]["200"]["content"]["text/plain"], undefined, unknown>;
    /** @summary Get marketing attributes for an application (Authorised Roles: SuperUser, ApplicationAdministrator) */
    getApplicationsApiGetApplicationAttributes: ServiceOperationQuery<{
        method: "get";
        url: "/rest/applications/attribs";
    }, paths["/rest/applications/attribs"]["get"]["responses"]["200"]["content"]["text/plain"], paths["/rest/applications/attribs"]["get"]["parameters"], unknown>;
    /** @summary Update marketing attributes for an application (Authorised Roles: SuperUser, ApplicationAdministrator) */
    postApplicationsApiUpdateApplicationAttributes: ServiceOperationMutation<{
        method: "post";
        url: "/rest/applications/attribs";
        mediaType: "application/json-patch+json";
    }, NonNullable<paths["/rest/applications/attribs"]["post"]["requestBody"]>["content"]["application/json-patch+json"], paths["/rest/applications/attribs"]["post"]["responses"]["200"]["content"]["text/plain"], undefined, unknown>;
    /** @summary Retrieves the list of application support teams for the current user's organization. (Authorised Roles: ProjectAdministrator, ProjectLeader, PlatformAdministrator, SuperUser) */
    getApplicationsApiGetApplicationTeamsForUserOrganization: ServiceOperationQuery<{
        method: "get";
        url: "/rest/applications/teams/{appId}";
    }, paths["/rest/applications/teams/{appId}"]["get"]["responses"]["200"]["content"]["text/plain"], paths["/rest/applications/teams/{appId}"]["get"]["parameters"], paths["/rest/applications/teams/{appId}"]["get"]["responses"]["400"]["content"]["text/plain"]>;
    /** @summary Retrieves the list of application teams for a given organization. (Authorised Roles: ProjectAdministrator, ProjectLeader, PlatformAdministrator, SuperUser) */
    getApplicationsApiGetApplicationTeams: ServiceOperationQuery<{
        method: "get";
        url: "/rest/applications/teams";
    }, paths["/rest/applications/teams"]["get"]["responses"]["200"]["content"]["text/plain"], paths["/rest/applications/teams"]["get"]["parameters"], paths["/rest/applications/teams"]["get"]["responses"]["400"]["content"]["text/plain"]>;
    /** @summary Gets Application support team users for the current user's Organization. (Authorised Roles: ProjectAdministrator, ProjectLeader, PlatformAdministrator, SuperUser) */
    getApplicationsApiGetApplicationSupportTeamUsersForOrg: ServiceOperationQuery<{
        method: "get";
        url: "/rest/applications/teams/support/{appId}";
    }, paths["/rest/applications/teams/support/{appId}"]["get"]["responses"]["200"]["content"]["text/plain"], paths["/rest/applications/teams/support/{appId}"]["get"]["parameters"], unknown>;
    /** @summary Adds a new team to the application. (Authorised Roles: PlatformAdministrator, SuperUser, ApplicationAdministrator) */
    putApplicationsApiAddTeam: ServiceOperationMutation<{
        method: "put";
        url: "/rest/applications/teams/support";
        mediaType: "application/json-patch+json";
    }, NonNullable<paths["/rest/applications/teams/support"]["put"]["requestBody"]>["content"]["application/json-patch+json"], paths["/rest/applications/teams/support"]["put"]["responses"]["200"]["content"]["text/plain"], undefined, unknown>;
    /** @summary Updates an application team (Authorised Roles: PlatformAdministrator, SuperUser, ApplicationAdministrator) */
    postApplicationsApiUpdateTeam: ServiceOperationMutation<{
        method: "post";
        url: "/rest/applications/teams/support";
        mediaType: "application/json-patch+json";
    }, NonNullable<paths["/rest/applications/teams/support"]["post"]["requestBody"]>["content"]["application/json-patch+json"], paths["/rest/applications/teams/support"]["post"]["responses"]["200"]["content"]["text/plain"], undefined, unknown>;
    /** @summary Gets a list of all image/pictogram keys for use when editing image attributes (Authorised Roles: SuperUser, ApplicationAdministrator) */
    getApplicationsApiGetPictograms: ServiceOperationQuery<{
        method: "get";
        url: "/rest/applications/pictograms";
    }, paths["/rest/applications/pictograms"]["get"]["responses"]["200"]["content"]["text/plain"], undefined, unknown>;
    /** @summary Gets a list of all users for use when editing application attributes key contacts (Authorised Roles: SuperUser, ApplicationAdministrator) */
    getApplicationsApiGetUsers: ServiceOperationQuery<{
        method: "get";
        url: "/rest/applications/users";
    }, paths["/rest/applications/users"]["get"]["responses"]["200"]["content"]["text/plain"], undefined, unknown>;
    /** @summary Gets a list of all accesses for an application (Authorised Roles: SuperUser, ApplicationAdministrator) */
    getApplicationsApiGetAccesses: ServiceOperationQuery<{
        method: "get";
        url: "/rest/applications/accesses";
    }, paths["/rest/applications/accesses"]["get"]["responses"]["200"]["content"]["text/plain"], paths["/rest/applications/accesses"]["get"]["parameters"], unknown>;
    /** @summary Sets the accesses for a role for an application. (Authorised Roles: SuperUser, ApplicationAdministrator) */
    postApplicationsApiSetAccesses: ServiceOperationMutation<{
        method: "post";
        url: "/rest/applications/accesses";
        mediaType: "application/json-patch+json";
    }, NonNullable<paths["/rest/applications/accesses"]["post"]["requestBody"]>["content"]["application/json-patch+json"], paths["/rest/applications/accesses"]["post"]["responses"]["200"]["content"]["text/plain"], paths["/rest/applications/accesses"]["post"]["parameters"], unknown>;
    /** @summary Gets a list of all entity types for an application (Authorised Roles: SuperUser, ApplicationAdministrator) */
    getApplicationsApiGetEntityTypes: ServiceOperationQuery<{
        method: "get";
        url: "/rest/applications/entityTypes";
    }, paths["/rest/applications/entityTypes"]["get"]["responses"]["200"]["content"]["text/plain"], paths["/rest/applications/entityTypes"]["get"]["parameters"], unknown>;
    /** @summary Adds a data asset permission (Authorised Roles: PlatformAdministrator, SuperUser, ApplicationAdministrator) */
    putApplicationsApiAddDataAssetPermission: ServiceOperationMutation<{
        method: "put";
        url: "/rest/applications/data-assets";
        mediaType: "application/json-patch+json";
    }, NonNullable<paths["/rest/applications/data-assets"]["put"]["requestBody"]>["content"]["application/json-patch+json"], paths["/rest/applications/data-assets"]["put"]["responses"]["200"]["content"]["text/plain"], undefined, unknown>;
    /** @summary Updates a data asset permission (Authorised Roles: PlatformAdministrator, SuperUser, ApplicationAdministrator) */
    postApplicationsApiUpdateDataAssetPermission: ServiceOperationMutation<{
        method: "post";
        url: "/rest/applications/data-assets";
        mediaType: "application/json-patch+json";
    }, NonNullable<paths["/rest/applications/data-assets"]["post"]["requestBody"]>["content"]["application/json-patch+json"], paths["/rest/applications/data-assets"]["post"]["responses"]["200"]["content"]["text/plain"], undefined, unknown>;
    /** @summary Deletes a data asset permission (Authorised Roles: PlatformAdministrator, SuperUser, ApplicationAdministrator) */
    deleteApplicationsApiDeleteDataAssetPermission: ServiceOperationMutation<{
        method: "delete";
        url: "/rest/applications/data-assets";
    }, undefined, paths["/rest/applications/data-assets"]["delete"]["responses"]["200"]["content"]["text/plain"], paths["/rest/applications/data-assets"]["delete"]["parameters"], unknown>;
    /** @summary Adds a file template role (Authorised Roles: PlatformAdministrator, SuperUser, ApplicationAdministrator) */
    putApplicationsApiAddFileTemplateRole: ServiceOperationMutation<{
        method: "put";
        url: "/rest/applications/file-templates";
        mediaType: "application/json-patch+json";
    }, NonNullable<paths["/rest/applications/file-templates"]["put"]["requestBody"]>["content"]["application/json-patch+json"], paths["/rest/applications/file-templates"]["put"]["responses"]["200"]["content"]["text/plain"], undefined, unknown>;
    /** @summary Updates the permissions on a file template role. (Authorised Roles: PlatformAdministrator, SuperUser, ApplicationAdministrator) */
    postApplicationsApiUpdateFileTemplateRole: ServiceOperationMutation<{
        method: "post";
        url: "/rest/applications/file-templates";
        mediaType: "application/json-patch+json";
    }, NonNullable<paths["/rest/applications/file-templates"]["post"]["requestBody"]>["content"]["application/json-patch+json"], paths["/rest/applications/file-templates"]["post"]["responses"]["200"]["content"]["text/plain"], undefined, unknown>;
    /** @summary Deletes a file template role. (Authorised Roles: PlatformAdministrator, SuperUser, ApplicationAdministrator) */
    deleteApplicationsApiDeleteFileTemplateRole: ServiceOperationMutation<{
        method: "delete";
        url: "/rest/applications/file-templates";
    }, undefined, unknown, paths["/rest/applications/file-templates"]["delete"]["parameters"], unknown>;
    /** @summary  (Authorised Roles: SuperUser, ApplicationAdministrator) */
    getApplicationsApiGetRolePermissions: ServiceOperationQuery<{
        method: "get";
        url: "/rest/applications/roles/permissions";
    }, paths["/rest/applications/roles/permissions"]["get"]["responses"]["200"]["content"]["text/plain"], paths["/rest/applications/roles/permissions"]["get"]["parameters"], unknown>;
    /** @summary Get an apps settings (json response) */
    getAppSettingsApiGetAppSettings: ServiceOperationQuery<{
        method: "get";
        url: "/rest/app-settings/{applicationId}";
    }, paths["/rest/app-settings/{applicationId}"]["get"]["responses"]["200"]["content"]["text/plain"], paths["/rest/app-settings/{applicationId}"]["get"]["parameters"], unknown>;
    /** @summary Get an apps settings as downloadable json file */
    getAppSettingsApiGetAppSettingsDownloadFile: ServiceOperationQuery<{
        method: "get";
        url: "/rest/app-settings/download/{applicationId}";
    }, paths["/rest/app-settings/download/{applicationId}"]["get"]["responses"]["200"]["content"]["text/plain"], paths["/rest/app-settings/download/{applicationId}"]["get"]["parameters"], unknown>;
    /**
     * @summary Upload an App Settings (Export) file to be imported into this environment.
     * File will automatically be checked to see what differences there are between the file and this environment (Authorised Roles: SuperUser, ApplicationAdministrator)
     */
    postAppSettingsApiAppSettingsUpload: ServiceOperationMutation<{
        method: "post";
        url: "/rest/app-settings/upload";
        mediaType: "multipart/form-data";
    }, NonNullable<paths["/rest/app-settings/upload"]["post"]["requestBody"]>["content"]["multipart/form-data"], paths["/rest/app-settings/upload"]["post"]["responses"]["200"]["content"]["text/plain"], undefined, unknown>;
    /** @summary Gets a list of previously uploaded app settings files */
    getAppSettingsApiGetAppSettingsUploads: ServiceOperationQuery<{
        method: "get";
        url: "/rest/app-settings-upload";
    }, paths["/rest/app-settings-upload"]["get"]["responses"]["200"]["content"]["text/plain"], undefined, unknown>;
    /** @summary Gets a specific app settings upload */
    getAppSettingsApiGetAppSettingsUpload: ServiceOperationQuery<{
        method: "get";
        url: "/rest/app-settings-upload/{appSettingsUploadId}";
    }, paths["/rest/app-settings-upload/{appSettingsUploadId}"]["get"]["responses"]["200"]["content"]["text/plain"], paths["/rest/app-settings-upload/{appSettingsUploadId}"]["get"]["parameters"], unknown>;
    /** @summary You can patch an app-settings-upload with a new status and an ApplyRequest to apply it (Authorised Roles: SuperUser, ApplicationAdministrator) */
    patchAppSettingsApiGetAppSettingsUpload: ServiceOperationMutation<{
        method: "patch";
        url: "/rest/app-settings-upload/{appSettingsUploadId}";
        mediaType: "application/json-patch+json";
    }, NonNullable<paths["/rest/app-settings-upload/{appSettingsUploadId}"]["patch"]["requestBody"]>["content"]["application/json-patch+json"], paths["/rest/app-settings-upload/{appSettingsUploadId}"]["patch"]["responses"]["200"]["content"]["text/plain"], paths["/rest/app-settings-upload/{appSettingsUploadId}"]["patch"]["parameters"], unknown>;
    /** @summary Logs a user into the DMP application by using the code returned to the front end by the PwC identity service and returns a jwt token */
    postAuthenticationApiGetToken: ServiceOperationMutation<{
        method: "post";
        url: "/rest/getToken";
    }, undefined, paths["/rest/getToken"]["post"]["responses"]["200"]["content"]["text/plain"], paths["/rest/getToken"]["post"]["parameters"], unknown>;
    /** @summary Logs a user out by removing their token from cache and adding to blacklist */
    postAuthenticationApiLogout: ServiceOperationMutation<{
        method: "post";
        url: "/rest/logout";
    }, undefined, unknown, undefined, unknown>;
    /** @summary Logs out another user by their userId */
    postAuthenticationApiLogoutUser: ServiceOperationMutation<{
        method: "post";
        url: "/rest/logout/{userId}";
    }, undefined, unknown, paths["/rest/logout/{userId}"]["post"]["parameters"], unknown>;
    postCatalogApiRegisterApplication: ServiceOperationMutation<{
        method: "post";
        url: "/rest/catalog/register";
        mediaType: "application/json-patch+json";
    }, NonNullable<paths["/rest/catalog/register"]["post"]["requestBody"]>["content"]["application/json-patch+json"], paths["/rest/catalog/register"]["post"]["responses"]["200"]["content"]["text/plain"], undefined, unknown>;
    postCatalogApiContentHandler: ServiceOperationMutation<{
        method: "post";
        url: "/rest/catalog/handler/content";
        mediaType: "application/json-patch+json";
    }, NonNullable<paths["/rest/catalog/handler/content"]["post"]["requestBody"]>["content"]["application/json-patch+json"], paths["/rest/catalog/handler/content"]["post"]["responses"]["200"]["content"]["text/plain"], undefined, unknown>;
    /** @summary Get all chats for an application (Authorised Roles: SuperUser, ApplicationAdministrator) */
    getChatApiGetChat: ServiceOperationQuery<{
        method: "get";
        url: "/rest/chat/{applicationId}";
    }, paths["/rest/chat/{applicationId}"]["get"]["responses"]["200"]["content"]["text/plain"], paths["/rest/chat/{applicationId}"]["get"]["parameters"], unknown>;
    /** @summary Add a new chat on an application (Authorised Roles: SuperUser, ApplicationAdministrator) */
    putChatApiAddChat: ServiceOperationMutation<{
        method: "put";
        url: "/rest/chat/{applicationId}";
        mediaType: "application/json-patch+json";
    }, NonNullable<paths["/rest/chat/{applicationId}"]["put"]["requestBody"]>["content"]["application/json-patch+json"], paths["/rest/chat/{applicationId}"]["put"]["responses"]["200"]["content"]["text/plain"], paths["/rest/chat/{applicationId}"]["put"]["parameters"], unknown>;
    /** @summary Update a chat */
    postChatApiPostChat: ServiceOperationMutation<{
        method: "post";
        url: "/rest/chat/{applicationId}";
        mediaType: "application/json-patch+json";
    }, NonNullable<paths["/rest/chat/{applicationId}"]["post"]["requestBody"]>["content"]["application/json-patch+json"], paths["/rest/chat/{applicationId}"]["post"]["responses"]["200"]["content"]["text/plain"], paths["/rest/chat/{applicationId}"]["post"]["parameters"], unknown>;
    /** @summary Get a single chat (Authorised Roles: SuperUser, ApplicationAdministrator) */
    getChatApiGetChatItem: ServiceOperationQuery<{
        method: "get";
        url: "/rest/chat/{applicationId}/{chatId}";
    }, paths["/rest/chat/{applicationId}/{chatId}"]["get"]["responses"]["200"]["content"]["text/plain"], paths["/rest/chat/{applicationId}/{chatId}"]["get"]["parameters"], unknown>;
    /** @summary Adds a new data asset. (Authorised Roles: SuperUser, ApplicationAdministrator) */
    putDataAssetApiAddDataAsset: ServiceOperationMutation<{
        method: "put";
        url: "/rest/data_asset";
        mediaType: "application/json-patch+json";
    }, NonNullable<paths["/rest/data_asset"]["put"]["requestBody"]>["content"]["application/json-patch+json"], paths["/rest/data_asset"]["put"]["responses"]["200"]["content"]["text/plain"], undefined, unknown>;
    /** @summary Updates a data asset. (Authorised Roles: SuperUser, ApplicationAdministrator) */
    postDataAssetApiUpdateTemplate: ServiceOperationMutation<{
        method: "post";
        url: "/rest/data_asset";
        mediaType: "application/json-patch+json";
    }, NonNullable<paths["/rest/data_asset"]["post"]["requestBody"]>["content"]["application/json-patch+json"], paths["/rest/data_asset"]["post"]["responses"]["200"]["content"]["text/plain"], undefined, unknown>;
    /** @summary Deletes a data asset. (Authorised Roles: SuperUser, ApplicationAdministrator) */
    deleteDataAssetApiDeleteTemplate: ServiceOperationMutation<{
        method: "delete";
        url: "/rest/data_asset";
        mediaType: "application/json-patch+json";
    }, NonNullable<paths["/rest/data_asset"]["delete"]["requestBody"]>["content"]["application/json-patch+json"], paths["/rest/data_asset"]["delete"]["responses"]["200"]["content"]["text/plain"], undefined, unknown>;
    /** @summary List data assets for an application / entity type (Authorised Roles: SuperUser, ApplicationAdministrator) */
    getDataAssetApiListDataAssets: ServiceOperationQuery<{
        method: "get";
        url: "/rest/data_asset";
    }, paths["/rest/data_asset"]["get"]["responses"]["200"]["content"]["text/plain"], paths["/rest/data_asset"]["get"]["parameters"], unknown>;
    /** @summary Gets the summary of data assets for a specific application and project. */
    getDataAssetApiGetTemplateSummary: ServiceOperationQuery<{
        method: "get";
        url: "/rest/data_asset/summary/{applicationId},{projectId}";
    }, paths["/rest/data_asset/summary/{applicationId},{projectId}"]["get"]["responses"]["200"]["content"]["text/plain"], paths["/rest/data_asset/summary/{applicationId},{projectId}"]["get"]["parameters"], unknown>;
    /** @summary Gets the activity log of a specific data asset. */
    getDataAssetApiGetSpecificDataAssetSummary: ServiceOperationQuery<{
        method: "get";
        url: "/rest/data_asset/activity_log/{applicationId},{projectId},{entityId},{dataAssetId}";
    }, paths["/rest/data_asset/activity_log/{applicationId},{projectId},{entityId},{dataAssetId}"]["get"]["responses"]["200"]["content"]["text/plain"], paths["/rest/data_asset/activity_log/{applicationId},{projectId},{entityId},{dataAssetId}"]["get"]["parameters"], unknown>;
    /** @summary Updates the state of a data asset. */
    postDataAssetApiPostTransitionUpdate: ServiceOperationMutation<{
        method: "post";
        url: "/rest/data_asset/transition";
        mediaType: "multipart/form-data";
    }, NonNullable<paths["/rest/data_asset/transition"]["post"]["requestBody"]>["content"]["multipart/form-data"], paths["/rest/data_asset/transition"]["post"]["responses"]["200"]["content"]["text/plain"], undefined, unknown>;
    /** @summary Checks that Databricks instance is accessible and configured correctly (Authorised Roles: PlatformAdministrator, SuperUser, ApplicationAdministrator) */
    getDatabricksApiGetDatabricksStatus: ServiceOperationQuery<{
        method: "get";
        url: "/rest/databricks/connection";
    }, paths["/rest/databricks/connection"]["get"]["responses"]["200"]["content"]["text/plain"], undefined, unknown>;
    /** @summary Initialise Databricks environment. Creates user groups, compute policy, compute clusters, permissions, unity catalog (Authorised Roles: SuperUser) */
    putDatabricksApiInitialiseDatabricks: ServiceOperationMutation<{
        method: "put";
        url: "/rest/databricks/connection";
    }, undefined, paths["/rest/databricks/connection"]["put"]["responses"]["200"]["content"]["text/plain"], undefined, unknown>;
    /** @summary Checks that Databricks enabled application has then necessary parts configured in Databricks (Authorised Roles: PlatformAdministrator, SuperUser, ApplicationAdministrator) */
    getDatabricksApiGetDatabricksApplicationStatus: ServiceOperationQuery<{
        method: "get";
        url: "/rest/databricks/application";
    }, paths["/rest/databricks/application"]["get"]["responses"]["200"]["content"]["text/plain"], paths["/rest/databricks/application"]["get"]["parameters"], unknown>;
    /** @summary Provisions a Databricks enabled application on Databricks. Creates development application folder, developer group, cross-development schema, development schemas, and assigns permissions to folder/compute/catalogs (Authorised Roles: SuperUser, ApplicationAdministrator) */
    putDatabricksApiProvisionApplication: ServiceOperationMutation<{
        method: "put";
        url: "/rest/databricks/application";
    }, undefined, paths["/rest/databricks/application"]["put"]["responses"]["200"]["content"]["text/plain"], paths["/rest/databricks/application"]["put"]["parameters"], unknown>;
    /**
     * @summary Promotes a Databricks enabled application on Databricks.
     * Deletes existing production folder if it exists.
     * Creates production application folder, developer group, cross-development schema, development schemas, and assigns permissions to folder/compute/catalogs.
     * Copies notebooks, cross client data (volumes) from development to production folder. (Authorised Roles: SuperUser, ApplicationAdministrator)
     */
    postDatabricksApiPromoteApplication: ServiceOperationMutation<{
        method: "post";
        url: "/rest/databricks/application/promote";
    }, undefined, paths["/rest/databricks/application/promote"]["post"]["responses"]["200"]["content"]["text/plain"], paths["/rest/databricks/application/promote"]["post"]["parameters"], unknown>;
    /** @summary Adds a new template notebook/.ipynb to a Databricks application, to be used as the template for all workspaces (Authorised Roles: SuperUser, ApplicationAdministrator) */
    putDatabricksApiAddDefaultApplicationNotebook: ServiceOperationMutation<{
        method: "put";
        url: "/rest/databricks/application/notebooks";
    }, undefined, paths["/rest/databricks/application/notebooks"]["put"]["responses"]["200"]["content"]["text/plain"], paths["/rest/databricks/application/notebooks"]["put"]["parameters"], unknown>;
    /** @summary Adds a notebook/.ipynb to a Databricks application, to be used as the template for all workspaces (Authorised Roles: SuperUser, ApplicationAdministrator) */
    postDatabricksApiAddApplicationNotebook: ServiceOperationMutation<{
        method: "post";
        url: "/rest/databricks/application/notebooks";
        mediaType: "multipart/form-data";
    }, NonNullable<paths["/rest/databricks/application/notebooks"]["post"]["requestBody"]>["content"]["multipart/form-data"], paths["/rest/databricks/application/notebooks"]["post"]["responses"]["200"]["content"]["text/plain"], undefined, unknown>;
    /** @summary Checks the current status of a Databricks workspace linked to a Databricks enabled application (Authorised Roles: ProjectAdministrator, ProjectLeader, PlatformAdministrator, SuperUser, ApplicationAdministrator) */
    getDatabricksApiGetDatabricksWorkspaceStatus: ServiceOperationQuery<{
        method: "get";
        url: "/rest/databricks/workspace";
    }, paths["/rest/databricks/workspace"]["get"]["responses"]["200"]["content"]["text/plain"], paths["/rest/databricks/workspace"]["get"]["parameters"], unknown>;
    /** @summary Sets up Databricks for new workspace. Creates service principal, grants access, creates result reader group, workspace catalog and workspace job run (Authorised Roles: ProjectAdministrator, ProjectLeader, PlatformAdministrator, SuperUser, ApplicationAdministrator) */
    putDatabricksApiCreateDatabricksWorkspace: ServiceOperationMutation<{
        method: "put";
        url: "/rest/databricks/workspace";
    }, undefined, paths["/rest/databricks/workspace"]["put"]["responses"]["200"]["content"]["text/plain"], paths["/rest/databricks/workspace"]["put"]["parameters"], unknown>;
    /** @summary Syncs Jobs with the Production notebooks (Authorised Roles: PlatformAdministrator, SuperUser, ApplicationAdministrator) */
    putDatabricksApiSyncDatabricksWorkspaceJobs: ServiceOperationMutation<{
        method: "put";
        url: "/rest/databricks/workspace/jobs/sync";
    }, undefined, paths["/rest/databricks/workspace/jobs/sync"]["put"]["responses"]["200"]["content"]["text/plain"], paths["/rest/databricks/workspace/jobs/sync"]["put"]["parameters"], unknown>;
    /** @summary Runs a Job with the Production notebook (Authorised Roles: PlatformAdministrator, SuperUser, ApplicationAdministrator) */
    putDatabricksApiRunDatabricksWorkspaceJobs: ServiceOperationMutation<{
        method: "put";
        url: "/rest/databricks/workspace/jobs/run";
    }, undefined, paths["/rest/databricks/workspace/jobs/run"]["put"]["responses"]["200"]["content"]["text/plain"], paths["/rest/databricks/workspace/jobs/run"]["put"]["parameters"], unknown>;
    /** @summary Gets a PowerBi datasource file (.pbids) configured to connect to the Databricks instance using a particular users credentials (Authorised Roles: ProjectAdministrator, ProjectLeader, PlatformAdministrator, SuperUser, ApplicationAdministrator) */
    getDatabricksApiGetDatabricksWorkspacePowerBi: ServiceOperationQuery<{
        method: "get";
        url: "/rest/databricks/workspace/powerbi";
    }, paths["/rest/databricks/workspace/powerbi"]["get"]["responses"]["200"]["content"]["text/plain"], paths["/rest/databricks/workspace/powerbi"]["get"]["parameters"], unknown>;
    /** @summary Creates an entityType based on ApplicationId, name, and description. (Authorised Roles: SuperUser, ApplicationAdministrator) */
    postEntityTypeApiCreateEntityType: ServiceOperationMutation<{
        method: "post";
        url: "/rest/entitytypes/entityType";
        mediaType: "application/json-patch+json";
    }, NonNullable<paths["/rest/entitytypes/entityType"]["post"]["requestBody"]>["content"]["application/json-patch+json"], paths["/rest/entitytypes/entityType"]["post"]["responses"]["201"]["content"]["text/plain"], undefined, unknown>;
    /** @summary Updates an existing entityType based on its ID contained in the request. (Authorised Roles: SuperUser, ApplicationAdministrator) */
    putEntityTypeApiUpdateEntityType: ServiceOperationMutation<{
        method: "put";
        url: "/rest/entitytypes/entityType";
        mediaType: "application/json-patch+json";
    }, NonNullable<paths["/rest/entitytypes/entityType"]["put"]["requestBody"]>["content"]["application/json-patch+json"], paths["/rest/entitytypes/entityType"]["put"]["responses"]["200"]["content"]["text/plain"], undefined, unknown>;
    /** @summary Returns all entity types for an application */
    getEntityTypeApiGetEntityTypesByApplicationId: ServiceOperationQuery<{
        method: "get";
        url: "/rest/entitytypes/application/{applicationId}";
    }, paths["/rest/entitytypes/application/{applicationId}"]["get"]["responses"]["200"]["content"]["text/plain"], paths["/rest/entitytypes/application/{applicationId}"]["get"]["parameters"], unknown>;
    /** @summary  (Authorised Roles: SuperUser, ApplicationAdministrator) */
    deleteEntityTypeApiDeleteEntityType: ServiceOperationMutation<{
        method: "delete";
        url: "/rest/entitytypes/{id}";
    }, undefined, unknown, paths["/rest/entitytypes/{id}"]["delete"]["parameters"], unknown>;
    /** @summary Get a whole collection of questions for an application */
    getFaqApiGetFaq: ServiceOperationQuery<{
        method: "get";
        url: "/rest/faq/{applicationId}";
    }, paths["/rest/faq/{applicationId}"]["get"]["responses"]["200"]["content"]["text/plain"], paths["/rest/faq/{applicationId}"]["get"]["parameters"], unknown>;
    /** @summary PUT a new question on an application */
    putFaqApiAddFaq: ServiceOperationMutation<{
        method: "put";
        url: "/rest/faq/{applicationId}";
        mediaType: "application/json-patch+json";
    }, NonNullable<paths["/rest/faq/{applicationId}"]["put"]["requestBody"]>["content"]["application/json-patch+json"], paths["/rest/faq/{applicationId}"]["put"]["responses"]["200"]["content"]["text/plain"], paths["/rest/faq/{applicationId}"]["put"]["parameters"], unknown>;
    /** @summary POST a whole Faq to update the entire collection, eg. for sort orders */
    postFaqApiPostFaq: ServiceOperationMutation<{
        method: "post";
        url: "/rest/faq/{applicationId}";
        mediaType: "application/json-patch+json";
    }, NonNullable<paths["/rest/faq/{applicationId}"]["post"]["requestBody"]>["content"]["application/json-patch+json"], paths["/rest/faq/{applicationId}"]["post"]["responses"]["200"]["content"]["text/plain"], paths["/rest/faq/{applicationId}"]["post"]["parameters"], unknown>;
    /** @summary Get a single question in an application */
    getFaqApiGetFaqItem: ServiceOperationQuery<{
        method: "get";
        url: "/rest/faq/{applicationId}/{questionId}";
    }, paths["/rest/faq/{applicationId}/{questionId}"]["get"]["responses"]["200"]["content"]["text/plain"], paths["/rest/faq/{applicationId}/{questionId}"]["get"]["parameters"], unknown>;
    /** @summary Update a single question in an application */
    patchFaqApiUpdateFaqItem: ServiceOperationMutation<{
        method: "patch";
        url: "/rest/faq/{applicationId}/{questionId}";
        mediaType: "application/json-patch+json";
    }, NonNullable<paths["/rest/faq/{applicationId}/{questionId}"]["patch"]["requestBody"]>["content"]["application/json-patch+json"], paths["/rest/faq/{applicationId}/{questionId}"]["patch"]["responses"]["200"]["content"]["text/plain"], paths["/rest/faq/{applicationId}/{questionId}"]["patch"]["parameters"], unknown>;
    /** @summary Delete a single question in an application */
    deleteFaqApiDeleteFaqItem: ServiceOperationMutation<{
        method: "delete";
        url: "/rest/faq/{applicationId}/{questionId}";
    }, undefined, paths["/rest/faq/{applicationId}/{questionId}"]["delete"]["responses"]["200"]["content"]["text/plain"], paths["/rest/faq/{applicationId}/{questionId}"]["delete"]["parameters"], unknown>;
    /** @summary Get a whole collection of terms for an application */
    getGlossaryApiGetGlossary: ServiceOperationQuery<{
        method: "get";
        url: "/rest/glossary/{applicationId}";
    }, paths["/rest/glossary/{applicationId}"]["get"]["responses"]["200"]["content"]["text/plain"], paths["/rest/glossary/{applicationId}"]["get"]["parameters"], unknown>;
    /** @summary PUT a new term on an application */
    putGlossaryApiAddGlossary: ServiceOperationMutation<{
        method: "put";
        url: "/rest/glossary/{applicationId}";
        mediaType: "application/json-patch+json";
    }, NonNullable<paths["/rest/glossary/{applicationId}"]["put"]["requestBody"]>["content"]["application/json-patch+json"], paths["/rest/glossary/{applicationId}"]["put"]["responses"]["200"]["content"]["text/plain"], paths["/rest/glossary/{applicationId}"]["put"]["parameters"], unknown>;
    /** @summary POST a whole glossary to update the entire collection, eg. for sort orders */
    postGlossaryApiPostGlossary: ServiceOperationMutation<{
        method: "post";
        url: "/rest/glossary/{applicationId}";
        mediaType: "application/json-patch+json";
    }, NonNullable<paths["/rest/glossary/{applicationId}"]["post"]["requestBody"]>["content"]["application/json-patch+json"], paths["/rest/glossary/{applicationId}"]["post"]["responses"]["200"]["content"]["text/plain"], paths["/rest/glossary/{applicationId}"]["post"]["parameters"], unknown>;
    /** @summary Get a single term in an application */
    getGlossaryApiGetGlossaryItem: ServiceOperationQuery<{
        method: "get";
        url: "/rest/glossary/{applicationId}/{termId}";
    }, paths["/rest/glossary/{applicationId}/{termId}"]["get"]["responses"]["200"]["content"]["text/plain"], paths["/rest/glossary/{applicationId}/{termId}"]["get"]["parameters"], unknown>;
    /** @summary Update a single term in an application */
    patchGlossaryApiUpdateGlossaryItem: ServiceOperationMutation<{
        method: "patch";
        url: "/rest/glossary/{applicationId}/{termId}";
        mediaType: "application/json-patch+json";
    }, NonNullable<paths["/rest/glossary/{applicationId}/{termId}"]["patch"]["requestBody"]>["content"]["application/json-patch+json"], paths["/rest/glossary/{applicationId}/{termId}"]["patch"]["responses"]["200"]["content"]["text/plain"], paths["/rest/glossary/{applicationId}/{termId}"]["patch"]["parameters"], unknown>;
    /** @summary Delete a single term in an application */
    deleteGlossaryApiDeleteGlossaryItem: ServiceOperationMutation<{
        method: "delete";
        url: "/rest/glossary/{applicationId}/{termId}";
    }, undefined, paths["/rest/glossary/{applicationId}/{termId}"]["delete"]["responses"]["200"]["content"]["text/plain"], paths["/rest/glossary/{applicationId}/{termId}"]["delete"]["parameters"], unknown>;
    getLandingApiGetApplicationExternal: ServiceOperationQuery<{
        method: "get";
        url: "/rest/application_external";
    }, paths["/rest/application_external"]["get"]["responses"]["200"]["content"]["text/plain"], undefined, unknown>;
    getLandingApiGetApplicationInfoExternal: ServiceOperationQuery<{
        method: "get";
        url: "/rest/application_info_external/{applicationId}";
    }, paths["/rest/application_info_external/{applicationId}"]["get"]["responses"]["200"]["content"]["text/plain"], paths["/rest/application_info_external/{applicationId}"]["get"]["parameters"], unknown>;
    getLandingApiGetPlatformExternal: ServiceOperationQuery<{
        method: "get";
        url: "/rest/platform_external";
    }, paths["/rest/platform_external"]["get"]["responses"]["200"]["content"]["text/plain"], undefined, unknown>;
    /** @summary  (Authorised Roles: ProjectMember) */
    getLandingApiGetApplicationProjects: ServiceOperationQuery<{
        method: "get";
        url: "/rest/application_projects";
    }, paths["/rest/application_projects"]["get"]["responses"]["200"]["content"]["text/plain"], undefined, unknown>;
    /** @summary  (Authorised Roles: ProjectMember) */
    getLandingApiGetProjects: ServiceOperationQuery<{
        method: "get";
        url: "/rest/projects";
    }, paths["/rest/projects"]["get"]["responses"]["200"]["content"]["text/plain"], undefined, unknown>;
    /** @summary  (Authorised Roles: ProjectMember) */
    getLandingApiGetApplications: ServiceOperationQuery<{
        method: "get";
        url: "/rest/applications";
    }, paths["/rest/applications"]["get"]["responses"]["200"]["content"]["text/plain"], undefined, unknown>;
    /** @summary  (Authorised Roles: ProjectMember) */
    getLandingApiGetPlatformOperations: ServiceOperationQuery<{
        method: "get";
        url: "/rest/platform";
    }, paths["/rest/platform"]["get"]["responses"]["200"]["content"]["text/plain"], paths["/rest/platform"]["get"]["parameters"], unknown>;
    /** @summary Get all pipelines for an application (Authorised Roles: SuperUser, ApplicationAdministrator) */
    getPipelineApiGetPipeline: ServiceOperationQuery<{
        method: "get";
        url: "/rest/pipeline/{applicationId}";
    }, paths["/rest/pipeline/{applicationId}"]["get"]["responses"]["200"]["content"]["text/plain"], paths["/rest/pipeline/{applicationId}"]["get"]["parameters"], unknown>;
    /** @summary Add a new pipeline on an application (Authorised Roles: SuperUser, ApplicationAdministrator) */
    putPipelineApiAddPipeline: ServiceOperationMutation<{
        method: "put";
        url: "/rest/pipeline/{applicationId}";
        mediaType: "application/json-patch+json";
    }, NonNullable<paths["/rest/pipeline/{applicationId}"]["put"]["requestBody"]>["content"]["application/json-patch+json"], paths["/rest/pipeline/{applicationId}"]["put"]["responses"]["200"]["content"]["text/plain"], paths["/rest/pipeline/{applicationId}"]["put"]["parameters"], unknown>;
    /** @summary Update a pipeline */
    postPipelineApiPostPipeline: ServiceOperationMutation<{
        method: "post";
        url: "/rest/pipeline/{applicationId}";
        mediaType: "application/json-patch+json";
    }, NonNullable<paths["/rest/pipeline/{applicationId}"]["post"]["requestBody"]>["content"]["application/json-patch+json"], paths["/rest/pipeline/{applicationId}"]["post"]["responses"]["200"]["content"]["text/plain"], paths["/rest/pipeline/{applicationId}"]["post"]["parameters"], unknown>;
    /** @summary Get a single pipeline (Authorised Roles: SuperUser, ApplicationAdministrator) */
    getPipelineApiGetPipelineItem: ServiceOperationQuery<{
        method: "get";
        url: "/rest/pipeline/{applicationId}/{pipelineId}";
    }, paths["/rest/pipeline/{applicationId}/{pipelineId}"]["get"]["responses"]["200"]["content"]["text/plain"], paths["/rest/pipeline/{applicationId}/{pipelineId}"]["get"]["parameters"], unknown>;
    /** @summary  (Authorised Roles: ProjectLeader, PlatformAdministrator, SuperUser) */
    getProjectsApiGetUsers: ServiceOperationQuery<{
        method: "get";
        url: "/rest/projects/users";
    }, paths["/rest/projects/users"]["get"]["responses"]["200"]["content"]["text/plain"], paths["/rest/projects/users"]["get"]["parameters"], unknown>;
    /** @summary  (Authorised Roles: ProjectAdministrator, ProjectLeader, PlatformAdministrator, SuperUser) */
    putProjectsApiAddUserToProject: ServiceOperationMutation<{
        method: "put";
        url: "/rest/projects/users";
        mediaType: "application/json-patch+json";
    }, NonNullable<paths["/rest/projects/users"]["put"]["requestBody"]>["content"]["application/json-patch+json"], paths["/rest/projects/users"]["put"]["responses"]["200"]["content"]["text/plain"], undefined, unknown>;
    /** @summary  (Authorised Roles: ProjectAdministrator, ProjectLeader, PlatformAdministrator, SuperUser) */
    deleteProjectsApiRemoveUserFromProject: ServiceOperationMutation<{
        method: "delete";
        url: "/rest/projects/users";
        mediaType: "application/json-patch+json";
    }, NonNullable<paths["/rest/projects/users"]["delete"]["requestBody"]>["content"]["application/json-patch+json"], paths["/rest/projects/users"]["delete"]["responses"]["200"]["content"]["text/plain"], undefined, unknown>;
    /** @summary  (Authorised Roles: ProjectAdministrator, ProjectLeader, PlatformAdministrator, SuperUser) */
    putProjectsApiUpdateUserFromProject: ServiceOperationMutation<{
        method: "put";
        url: "/rest/projects/users/update";
        mediaType: "application/json-patch+json";
    }, NonNullable<paths["/rest/projects/users/update"]["put"]["requestBody"]>["content"]["application/json-patch+json"], paths["/rest/projects/users/update"]["put"]["responses"]["200"]["content"]["text/plain"], paths["/rest/projects/users/update"]["put"]["parameters"], unknown>;
    /** @summary Lists all projects in an organisation. (Authorised Roles: ProjectAdministrator, ProjectLeader, PlatformAdministrator, SuperUser) */
    getProjectsApiListOrganisationProjects: ServiceOperationQuery<{
        method: "get";
        url: "/rest/projects/organisation/projects";
    }, paths["/rest/projects/organisation/projects"]["get"]["responses"]["200"]["content"]["text/plain"], paths["/rest/projects/organisation/projects"]["get"]["parameters"], unknown>;
    /** @summary Adds a new project to an organisation. (Authorised Roles: ProjectLeader, PlatformAdministrator, SuperUser) */
    putProjectsApiAddProject: ServiceOperationMutation<{
        method: "put";
        url: "/rest/projects/organisation/projects";
        mediaType: "application/json-patch+json";
    }, NonNullable<paths["/rest/projects/organisation/projects"]["put"]["requestBody"]>["content"]["application/json-patch+json"], paths["/rest/projects/organisation/projects"]["put"]["responses"]["200"]["content"]["text/plain"], undefined, unknown>;
    /** @summary Updates an existing project within an organisation. (Authorised Roles: ProjectLeader, PlatformAdministrator, SuperUser) */
    postProjectsApiUpdateProject: ServiceOperationMutation<{
        method: "post";
        url: "/rest/projects/organisation/projects";
        mediaType: "application/json-patch+json";
    }, NonNullable<paths["/rest/projects/organisation/projects"]["post"]["requestBody"]>["content"]["application/json-patch+json"], paths["/rest/projects/organisation/projects"]["post"]["responses"]["200"]["content"]["text/plain"], undefined, unknown>;
    /** @summary Freezes a project, making it read-only. (Authorised Roles: PlatformAdministrator, SuperUser) */
    postProjectsApiFreezeProject: ServiceOperationMutation<{
        method: "post";
        url: "/rest/projects/organisation/projects/freeze";
        mediaType: "application/json-patch+json";
    }, NonNullable<paths["/rest/projects/organisation/projects/freeze"]["post"]["requestBody"]>["content"]["application/json-patch+json"], paths["/rest/projects/organisation/projects/freeze"]["post"]["responses"]["200"]["content"]["text/plain"], undefined, unknown>;
    /** @summary Unfreezes a project, making it editable again. (Authorised Roles: SuperUser) */
    postProjectsApiUnfreezeProject: ServiceOperationMutation<{
        method: "post";
        url: "/rest/projects/organisation/projects/unfreeze";
        mediaType: "application/json-patch+json";
    }, NonNullable<paths["/rest/projects/organisation/projects/unfreeze"]["post"]["requestBody"]>["content"]["application/json-patch+json"], paths["/rest/projects/organisation/projects/unfreeze"]["post"]["responses"]["200"]["content"]["text/plain"], undefined, unknown>;
    /** @summary Adds a new administrator to a project. (Authorised Roles: ProjectLeader, PlatformAdministrator, SuperUser) */
    putProjectsApiAddProjectAdmin: ServiceOperationMutation<{
        method: "put";
        url: "/rest/projects/organisation/projects/admins";
    }, undefined, paths["/rest/projects/organisation/projects/admins"]["put"]["responses"]["200"]["content"]["text/plain"], paths["/rest/projects/organisation/projects/admins"]["put"]["parameters"], unknown>;
    /** @summary Removes an administrator from a project. (Authorised Roles: ProjectLeader, PlatformAdministrator, SuperUser) */
    deleteProjectsApiRemoveProjectAdmin: ServiceOperationMutation<{
        method: "delete";
        url: "/rest/projects/organisation/projects/admins";
    }, undefined, paths["/rest/projects/organisation/projects/admins"]["delete"]["responses"]["200"]["content"]["text/plain"], paths["/rest/projects/organisation/projects/admins"]["delete"]["parameters"], unknown>;
    /** @summary Adds a new leader to a project. (Authorised Roles: PlatformAdministrator, SuperUser) */
    putProjectsApiAddProjectLeader: ServiceOperationMutation<{
        method: "put";
        url: "/rest/projects/organisation/projects/leaders";
    }, undefined, paths["/rest/projects/organisation/projects/leaders"]["put"]["responses"]["200"]["content"]["text/plain"], paths["/rest/projects/organisation/projects/leaders"]["put"]["parameters"], unknown>;
    /** @summary Removes a leader from a project. (Authorised Roles: PlatformAdministrator, SuperUser) */
    deleteProjectsApiRemoveProjectLeader: ServiceOperationMutation<{
        method: "delete";
        url: "/rest/projects/organisation/projects/leaders";
    }, undefined, paths["/rest/projects/organisation/projects/leaders"]["delete"]["responses"]["200"]["content"]["text/plain"], paths["/rest/projects/organisation/projects/leaders"]["delete"]["parameters"], unknown>;
    postStorageApiStorageFileRequirements: ServiceOperationMutation<{
        method: "post";
        url: "/rest/storage/fileRequirements";
    }, undefined, paths["/rest/storage/fileRequirements"]["post"]["responses"]["200"]["content"]["text/plain"], paths["/rest/storage/fileRequirements"]["post"]["parameters"], unknown>;
    /** @summary  (Authorised Roles: ProjectMember) */
    postStorageApiUploadFile: ServiceOperationMutation<{
        method: "post";
        url: "/rest/storage/upload_file";
        mediaType: "multipart/form-data";
    }, NonNullable<paths["/rest/storage/upload_file"]["post"]["requestBody"]>["content"]["multipart/form-data"], paths["/rest/storage/upload_file"]["post"]["responses"]["200"]["content"]["text/plain"], undefined, unknown>;
    /** @summary  (Authorised Roles: ProjectMember) */
    getStorageApiDownloadFile: ServiceOperationQuery<{
        method: "get";
        url: "/rest/storage/download_file/{blobName},{applicationId},{projectId},{fileType}";
    }, paths["/rest/storage/download_file/{blobName},{applicationId},{projectId},{fileType}"]["get"]["responses"]["200"]["content"]["text/plain"], paths["/rest/storage/download_file/{blobName},{applicationId},{projectId},{fileType}"]["get"]["parameters"], unknown>;
    /** @summary  (Authorised Roles: ProjectMember, ProjectAdministrator, ProjectLeader, SuperUser) */
    getStorageApiDownloadFileWorkspace: ServiceOperationQuery<{
        method: "get";
        url: "/rest/storage/download_file/workspace";
    }, paths["/rest/storage/download_file/workspace"]["get"]["responses"]["200"]["content"]["text/plain"], paths["/rest/storage/download_file/workspace"]["get"]["parameters"], unknown>;
    /** @summary Get a summary of storage/files, including counts per type (Authorised Roles: ProjectMember, ProjectAdministrator, ProjectLeader, SuperUser) */
    getStorageApiGetFilesSummary: ServiceOperationQuery<{
        method: "get";
        url: "/rest/storage/summary/{applicationId},{projectId}";
    }, paths["/rest/storage/summary/{applicationId},{projectId}"]["get"]["responses"]["200"]["content"]["text/plain"], paths["/rest/storage/summary/{applicationId},{projectId}"]["get"]["parameters"], unknown>;
    /** @summary Get a detailed list of files for a type, including filename, size, current indicator (Authorised Roles: ProjectMember, ProjectAdministrator, ProjectLeader, SuperUser) */
    getStorageApiGetFilesDetails: ServiceOperationQuery<{
        method: "get";
        url: "/rest/storage/details/{applicationId},{projectId},{type}";
    }, paths["/rest/storage/details/{applicationId},{projectId},{type}"]["get"]["responses"]["200"]["content"]["text/plain"], paths["/rest/storage/details/{applicationId},{projectId},{type}"]["get"]["parameters"], unknown>;
    /** @summary Get a detailed list of files for a workspace, including filename, size, current indicator (Authorised Roles: ProjectMember, ProjectAdministrator, ProjectLeader, SuperUser) */
    getStorageApiGetFilesDetailsWorkspace: ServiceOperationQuery<{
        method: "get";
        url: "/rest/storage/details/workspace";
    }, paths["/rest/storage/details/workspace"]["get"]["responses"]["200"]["content"]["text/plain"], paths["/rest/storage/details/workspace"]["get"]["parameters"], unknown>;
    /** @summary Get a detailed list of files for an entity, including filename, size, current indicator (Authorised Roles: ProjectMember, ProjectAdministrator, ProjectLeader, SuperUser) */
    getStorageApiGetFilesDetailsEntityTemplates: ServiceOperationQuery<{
        method: "get";
        url: "/rest/storage/details/entityTemplates";
    }, paths["/rest/storage/details/entityTemplates"]["get"]["responses"]["200"]["content"]["text/plain"], paths["/rest/storage/details/entityTemplates"]["get"]["parameters"], unknown>;
    /** @summary Get a detailed list of files for an entity, including filename, size (Authorised Roles: ProjectMember, ProjectAdministrator, ProjectLeader, SuperUser) */
    getStorageApiGetFilesDetailsEntityDataAssets: ServiceOperationQuery<{
        method: "get";
        url: "/rest/storage/details/entityDataAssets";
    }, paths["/rest/storage/details/entityDataAssets"]["get"]["responses"]["200"]["content"]["text/plain"], paths["/rest/storage/details/entityDataAssets"]["get"]["parameters"], unknown>;
    /** @summary Deletes all files of a particular type (for project/application) (Authorised Roles: ProjectAdministrator, ProjectLeader, SuperUser) */
    getStorageApiDeleteAll: ServiceOperationQuery<{
        method: "get";
        url: "/rest/storage/delete-all/{applicationId},{projectId},{type}";
    }, paths["/rest/storage/delete-all/{applicationId},{projectId},{type}"]["get"]["responses"]["200"]["content"]["text/plain"], paths["/rest/storage/delete-all/{applicationId},{projectId},{type}"]["get"]["parameters"], unknown>;
    /**
     * @summary Deletes all "unused" files of a particular type (for project/application)
     * eg. old template uploads (Authorised Roles: ProjectAdministrator, ProjectLeader, SuperUser)
     */
    getStorageApiDeleteUnused: ServiceOperationQuery<{
        method: "get";
        url: "/rest/storage/delete-unused/{applicationId},{projectId},{type}";
    }, paths["/rest/storage/delete-unused/{applicationId},{projectId},{type}"]["get"]["responses"]["200"]["content"]["text/plain"], paths["/rest/storage/delete-unused/{applicationId},{projectId},{type}"]["get"]["parameters"], unknown>;
    /** @summary  (Authorised Roles: ProjectMember, ProjectAdministrator, ProjectLeader, SuperUser) */
    postStorageApiDeleteFileWorkspace: ServiceOperationMutation<{
        method: "post";
        url: "/rest/storage/delete_file/workspace";
    }, undefined, paths["/rest/storage/delete_file/workspace"]["post"]["responses"]["200"]["content"]["text/plain"], paths["/rest/storage/delete_file/workspace"]["post"]["parameters"], unknown>;
    /**
     * @summary Migrates files for a project/application from the old storage format to the new storage format
     * Old: All files as blobs in a single container
     * New: Files structured in "folders" (Authorised Roles: ProjectAdministrator, ProjectLeader, SuperUser)
     */
    getStorageApiMigrate: ServiceOperationQuery<{
        method: "get";
        url: "/rest/storage/migrate/{applicationId},{projectId},{apply}";
    }, paths["/rest/storage/migrate/{applicationId},{projectId},{apply}"]["get"]["responses"]["200"]["content"]["text/plain"], paths["/rest/storage/migrate/{applicationId},{projectId},{apply}"]["get"]["parameters"], unknown>;
    /** @summary Gets details of job busy being applied (Authorised Roles: ProjectAdministrator, ProjectLeader, SuperUser) */
    getStorageApiGetMigrationJob: ServiceOperationQuery<{
        method: "get";
        url: "/rest/storage/migrate/{applicationId},{projectId},{jobId}";
    }, paths["/rest/storage/migrate/{applicationId},{projectId},{jobId}"]["get"]["responses"]["200"]["content"]["text/plain"], paths["/rest/storage/migrate/{applicationId},{projectId},{jobId}"]["get"]["parameters"], unknown>;
    /** @summary  (Authorised Roles: ProjectAdministrator, ProjectLeader, PlatformAdministrator, SuperUser) */
    getSubscriptionsApiGetOrganisation: ServiceOperationQuery<{
        method: "get";
        url: "/rest/subscriptions/organisation";
    }, paths["/rest/subscriptions/organisation"]["get"]["responses"]["200"]["content"]["text/plain"], paths["/rest/subscriptions/organisation"]["get"]["parameters"], unknown>;
    /** @summary Adds a new organisation. (Authorised Roles: SuperUser) */
    putSubscriptionsApiAddOrganisation: ServiceOperationMutation<{
        method: "put";
        url: "/rest/subscriptions/organisation";
        mediaType: "application/json-patch+json";
    }, NonNullable<paths["/rest/subscriptions/organisation"]["put"]["requestBody"]>["content"]["application/json-patch+json"], paths["/rest/subscriptions/organisation"]["put"]["responses"]["200"]["content"]["text/plain"], undefined, unknown>;
    /** @summary Updates an existing organisation. (Authorised Roles: PlatformAdministrator, SuperUser) */
    postSubscriptionsApiUpdateOrganisation: ServiceOperationMutation<{
        method: "post";
        url: "/rest/subscriptions/organisation";
        mediaType: "application/json-patch+json";
    }, NonNullable<paths["/rest/subscriptions/organisation"]["post"]["requestBody"]>["content"]["application/json-patch+json"], paths["/rest/subscriptions/organisation"]["post"]["responses"]["200"]["content"]["text/plain"], undefined, unknown>;
    /** @summary Retrieves the list of organisations. (Authorised Roles: ProjectMember, ProjectAdministrator, ProjectLeader, PlatformAdministrator, SuperUser) */
    getSubscriptionsApiGetOrganisations: ServiceOperationQuery<{
        method: "get";
        url: "/rest/subscriptions/organisations";
    }, paths["/rest/subscriptions/organisations"]["get"]["responses"]["200"]["content"]["text/plain"], undefined, unknown>;
    /** @summary Freezes an organisation, making it read-only. (Authorised Roles: ProjectAdministrator, PlatformAdministrator, SuperUser) */
    postSubscriptionsApiFreezeOrganisation: ServiceOperationMutation<{
        method: "post";
        url: "/rest/subscriptions/organisation/freeze";
        mediaType: "application/json-patch+json";
    }, NonNullable<paths["/rest/subscriptions/organisation/freeze"]["post"]["requestBody"]>["content"]["application/json-patch+json"], paths["/rest/subscriptions/organisation/freeze"]["post"]["responses"]["200"]["content"]["text/plain"], undefined, unknown>;
    /** @summary Return user (Authorised Roles: ProjectAdministrator, PlatformAdministrator, SuperUser) */
    getSubscriptionsApiGetOrganisationUser: ServiceOperationQuery<{
        method: "get";
        url: "/rest/subscriptions/organisation/user";
    }, paths["/rest/subscriptions/organisation/user"]["get"]["responses"]["200"]["content"]["text/plain"], paths["/rest/subscriptions/organisation/user"]["get"]["parameters"], unknown>;
    /** @summary Lists all users in an organisation. (Authorised Roles: ProjectAdministrator, ProjectLeader, PlatformAdministrator, SuperUser) */
    getSubscriptionsApiListOrganisationUsers: ServiceOperationQuery<{
        method: "get";
        url: "/rest/subscriptions/organisation/users";
    }, paths["/rest/subscriptions/organisation/users"]["get"]["responses"]["200"]["content"]["text/plain"], paths["/rest/subscriptions/organisation/users"]["get"]["parameters"], unknown>;
    /** @summary Adds a new user to an organisation. (Authorised Roles: ProjectAdministrator, ProjectLeader, PlatformAdministrator, SuperUser) */
    putSubscriptionsApiAddUser: ServiceOperationMutation<{
        method: "put";
        url: "/rest/subscriptions/organisation/users";
        mediaType: "application/json-patch+json";
    }, NonNullable<paths["/rest/subscriptions/organisation/users"]["put"]["requestBody"]>["content"]["application/json-patch+json"], paths["/rest/subscriptions/organisation/users"]["put"]["responses"]["200"]["content"]["text/plain"], undefined, unknown>;
    /** @summary Updates an existing user within an organisation. (Authorised Roles: ProjectAdministrator, ProjectLeader, PlatformAdministrator, SuperUser) */
    postSubscriptionsApiUpdateUser: ServiceOperationMutation<{
        method: "post";
        url: "/rest/subscriptions/organisation/users";
        mediaType: "application/json-patch+json";
    }, NonNullable<paths["/rest/subscriptions/organisation/users"]["post"]["requestBody"]>["content"]["application/json-patch+json"], paths["/rest/subscriptions/organisation/users"]["post"]["responses"]["200"]["content"]["text/plain"], undefined, unknown>;
    /** @summary Deletes a user from an organisation. (Authorised Roles: ProjectAdministrator, ProjectLeader, PlatformAdministrator, SuperUser) */
    deleteSubscriptionsApiDeleteUser: ServiceOperationMutation<{
        method: "delete";
        url: "/rest/subscriptions/organisation/users";
    }, undefined, paths["/rest/subscriptions/organisation/users"]["delete"]["responses"]["200"]["content"]["text/plain"], paths["/rest/subscriptions/organisation/users"]["delete"]["parameters"], unknown>;
    /** @summary Lists platform admins assigned to an organisation (Authorised Roles: ProjectAdministrator, ProjectLeader, PlatformAdministrator, SuperUser) */
    getSubscriptionsApiListOrganisationPlatformAdmins: ServiceOperationQuery<{
        method: "get";
        url: "/rest/subscriptions/organisations/admins";
    }, paths["/rest/subscriptions/organisations/admins"]["get"]["responses"]["200"]["content"]["text/plain"], paths["/rest/subscriptions/organisations/admins"]["get"]["parameters"], unknown>;
    /** @summary Assign a platform admin user to an organisation (Authorised Roles: SuperUser) */
    putSubscriptionsApiAddPlatformAdmin: ServiceOperationMutation<{
        method: "put";
        url: "/rest/subscriptions/organisations/admins";
    }, undefined, paths["/rest/subscriptions/organisations/admins"]["put"]["responses"]["200"]["content"]["text/plain"], paths["/rest/subscriptions/organisations/admins"]["put"]["parameters"], unknown>;
    /** @summary Unassign at platform admin from an organisation (Authorised Roles: SuperUser) */
    deleteSubscriptionsApiRemovePlatformAdmin: ServiceOperationMutation<{
        method: "delete";
        url: "/rest/subscriptions/organisations/admins";
    }, undefined, paths["/rest/subscriptions/organisations/admins"]["delete"]["responses"]["200"]["content"]["text/plain"], paths["/rest/subscriptions/organisations/admins"]["delete"]["parameters"], unknown>;
    /** @summary Lists all available platform admins (based on role) (Authorised Roles: SuperUser) */
    getSubscriptionsApiListAllPlatformAdmins: ServiceOperationQuery<{
        method: "get";
        url: "/rest/subscriptions/organisations/admins/all";
    }, paths["/rest/subscriptions/organisations/admins/all"]["get"]["responses"]["200"]["content"]["text/plain"], undefined, unknown>;
    /** @summary Freezes a user, making their account read-only. (Authorised Roles: ProjectAdministrator, ProjectLeader, PlatformAdministrator, SuperUser) */
    postSubscriptionsApiFreezeUser: ServiceOperationMutation<{
        method: "post";
        url: "/rest/subscriptions/organisation/users/freeze";
    }, undefined, paths["/rest/subscriptions/organisation/users/freeze"]["post"]["responses"]["200"]["content"]["text/plain"], paths["/rest/subscriptions/organisation/users/freeze"]["post"]["parameters"], unknown>;
    /** @summary Unfreezes a user, making their account active (Authorised Roles: PlatformAdministrator, SuperUser) */
    postSubscriptionsApiUnfreezeUser: ServiceOperationMutation<{
        method: "post";
        url: "/rest/subscriptions/organisation/users/unfreeze";
    }, undefined, paths["/rest/subscriptions/organisation/users/unfreeze"]["post"]["responses"]["200"]["content"]["text/plain"], paths["/rest/subscriptions/organisation/users/unfreeze"]["post"]["parameters"], unknown>;
    /** @summary Retrieves data for a specified project team (Authorised Roles: ProjectAdministrator, ProjectLeader, PlatformAdministrator, SuperUser) */
    getSubscriptionsApiGetOrganisationProjectTeam: ServiceOperationQuery<{
        method: "get";
        url: "/rest/subscriptions/organisations/teams/{teamId}";
    }, paths["/rest/subscriptions/organisations/teams/{teamId}"]["get"]["responses"]["200"]["content"]["text/plain"], paths["/rest/subscriptions/organisations/teams/{teamId}"]["get"]["parameters"], unknown>;
    /** @summary Retrieves the list of organisation project teams. (Authorised Roles: ProjectAdministrator, ProjectLeader, PlatformAdministrator, SuperUser) */
    getSubscriptionsApiGetOrganisationTeams: ServiceOperationQuery<{
        method: "get";
        url: "/rest/subscriptions/organisations/teams";
    }, paths["/rest/subscriptions/organisations/teams"]["get"]["responses"]["200"]["content"]["text/plain"], paths["/rest/subscriptions/organisations/teams"]["get"]["parameters"], unknown>;
    /** @summary Adds a new project team to the organisation. (Authorised Roles: ProjectLeader, PlatformAdministrator, SuperUser) */
    putSubscriptionsApiAddTeam: ServiceOperationMutation<{
        method: "put";
        url: "/rest/subscriptions/organisation/teams";
        mediaType: "application/json-patch+json";
    }, NonNullable<paths["/rest/subscriptions/organisation/teams"]["put"]["requestBody"]>["content"]["application/json-patch+json"], paths["/rest/subscriptions/organisation/teams"]["put"]["responses"]["200"]["content"]["text/plain"], undefined, unknown>;
    /** @summary Updates a project team (Authorised Roles: ProjectLeader, PlatformAdministrator, SuperUser) */
    postSubscriptionsApiUpdateTeam: ServiceOperationMutation<{
        method: "post";
        url: "/rest/subscriptions/organisation/teams";
        mediaType: "application/json-patch+json";
    }, NonNullable<paths["/rest/subscriptions/organisation/teams"]["post"]["requestBody"]>["content"]["application/json-patch+json"], paths["/rest/subscriptions/organisation/teams"]["post"]["responses"]["200"]["content"]["text/plain"], undefined, unknown>;
    /** @summary Freezes a team (Authorised Roles: ProjectLeader, PlatformAdministrator, SuperUser) */
    postSubscriptionsApiFreezeTeam: ServiceOperationMutation<{
        method: "post";
        url: "/rest/subscriptions/organisation/teams/freeze";
    }, undefined, paths["/rest/subscriptions/organisation/teams/freeze"]["post"]["responses"]["200"]["content"]["text/plain"], paths["/rest/subscriptions/organisation/teams/freeze"]["post"]["parameters"], unknown>;
    /** @summary  (Authorised Roles: ProjectAdministrator, ProjectLeader, PlatformAdministrator, SuperUser, ApplicationAdministrator) */
    getSubscriptionsApiListTeamUsers: ServiceOperationQuery<{
        method: "get";
        url: "/rest/subscriptions/organisation/teams/users";
    }, paths["/rest/subscriptions/organisation/teams/users"]["get"]["responses"]["200"]["content"]["text/plain"], paths["/rest/subscriptions/organisation/teams/users"]["get"]["parameters"], unknown>;
    /** @summary  (Authorised Roles: ProjectAdministrator, ProjectLeader, PlatformAdministrator, SuperUser) */
    postSubscriptionsApiAddTeamUser: ServiceOperationMutation<{
        method: "post";
        url: "/rest/subscriptions/organisation/teams/users";
        mediaType: "application/json-patch+json";
    }, NonNullable<paths["/rest/subscriptions/organisation/teams/users"]["post"]["requestBody"]>["content"]["application/json-patch+json"], paths["/rest/subscriptions/organisation/teams/users"]["post"]["responses"]["200"]["content"]["text/plain"], undefined, unknown>;
    /** @summary  (Authorised Roles: PlatformAdministrator, SuperUser) */
    deleteSubscriptionsApiDeleteTeamUser: ServiceOperationMutation<{
        method: "delete";
        url: "/rest/subscriptions/organisation/teams/users";
        mediaType: "application/json-patch+json";
    }, NonNullable<paths["/rest/subscriptions/organisation/teams/users"]["delete"]["requestBody"]>["content"]["application/json-patch+json"], paths["/rest/subscriptions/organisation/teams/users"]["delete"]["responses"]["200"]["content"]["text/plain"], undefined, paths["/rest/subscriptions/organisation/teams/users"]["delete"]["responses"]["400"]["content"]["text/plain"] | paths["/rest/subscriptions/organisation/teams/users"]["delete"]["responses"]["404"]["content"]["text/plain"] | paths["/rest/subscriptions/organisation/teams/users"]["delete"]["responses"]["500"]["content"]["text/plain"]>;
    /** @summary  (Authorised Roles: ProjectAdministrator, ProjectLeader, PlatformAdministrator, SuperUser, ApplicationAdministrator) */
    getSubscriptionsApiListTeamRoles: ServiceOperationQuery<{
        method: "get";
        url: "/rest/subscriptions/organisation/teams/roles";
    }, paths["/rest/subscriptions/organisation/teams/roles"]["get"]["responses"]["200"]["content"]["text/plain"], paths["/rest/subscriptions/organisation/teams/roles"]["get"]["parameters"], unknown>;
    /** @summary  (Authorised Roles: ProjectAdministrator, ProjectLeader, PlatformAdministrator, SuperUser) */
    putSubscriptionsApiAddTeamRole: ServiceOperationMutation<{
        method: "put";
        url: "/rest/subscriptions/organisation/teams/roles";
        mediaType: "application/json-patch+json";
    }, NonNullable<paths["/rest/subscriptions/organisation/teams/roles"]["put"]["requestBody"]>["content"]["application/json-patch+json"], paths["/rest/subscriptions/organisation/teams/roles"]["put"]["responses"]["200"]["content"]["text/plain"], undefined, unknown>;
    /** @summary  (Authorised Roles: PlatformAdministrator, SuperUser) */
    deleteSubscriptionsApiDeleteTeamRole: ServiceOperationMutation<{
        method: "delete";
        url: "/rest/subscriptions/organisation/teams/roles";
        mediaType: "application/json-patch+json";
    }, NonNullable<paths["/rest/subscriptions/organisation/teams/roles"]["delete"]["requestBody"]>["content"]["application/json-patch+json"], paths["/rest/subscriptions/organisation/teams/roles"]["delete"]["responses"]["200"]["content"]["text/plain"], undefined, unknown>;
    /** @summary  (Authorised Roles: ProjectAdministrator, ProjectLeader, PlatformAdministrator, SuperUser) */
    getSubscriptionsApiGetOrganisationWorkspaces: ServiceOperationQuery<{
        method: "get";
        url: "/rest/subscriptions/organisations/workspaces";
    }, paths["/rest/subscriptions/organisations/workspaces"]["get"]["responses"]["200"]["content"]["text/plain"], paths["/rest/subscriptions/organisations/workspaces"]["get"]["parameters"], unknown>;
    /** @summary  (Authorised Roles: ProjectLeader, PlatformAdministrator, SuperUser) */
    putSubscriptionsApiAddOrganisationWorkspaces: ServiceOperationMutation<{
        method: "put";
        url: "/rest/subscriptions/organisations/workspaces";
        mediaType: "application/json-patch+json";
    }, NonNullable<paths["/rest/subscriptions/organisations/workspaces"]["put"]["requestBody"]>["content"]["application/json-patch+json"], paths["/rest/subscriptions/organisations/workspaces"]["put"]["responses"]["200"]["content"]["text/plain"], undefined, unknown>;
    /** @summary  (Authorised Roles: ProjectLeader, PlatformAdministrator, SuperUser) */
    deleteSubscriptionsApiDeleteOrganisationWorkspaces: ServiceOperationMutation<{
        method: "delete";
        url: "/rest/subscriptions/organisations/workspaces";
        mediaType: "application/json-patch+json";
    }, NonNullable<paths["/rest/subscriptions/organisations/workspaces"]["delete"]["requestBody"]>["content"]["application/json-patch+json"], paths["/rest/subscriptions/organisations/workspaces"]["delete"]["responses"]["200"]["content"]["text/plain"], undefined, unknown>;
    /** @summary  (Authorised Roles: ProjectAdministrator, ProjectLeader, PlatformAdministrator, SuperUser) */
    getSubscriptionsApiGetOrganisationWorkspace: ServiceOperationQuery<{
        method: "get";
        url: "/rest/subscriptions/organisations/workspace";
    }, paths["/rest/subscriptions/organisations/workspace"]["get"]["responses"]["200"]["content"]["text/plain"], paths["/rest/subscriptions/organisations/workspace"]["get"]["parameters"], unknown>;
    /** @summary  (Authorised Roles: ProjectAdministrator, ProjectLeader, PlatformAdministrator, SuperUser) */
    getSubscriptionsApiGetOrganisationWorkspacesSummary: ServiceOperationQuery<{
        method: "get";
        url: "/rest/subscriptions/organisations/workspaces-summary";
    }, paths["/rest/subscriptions/organisations/workspaces-summary"]["get"]["responses"]["200"]["content"]["text/plain"], paths["/rest/subscriptions/organisations/workspaces-summary"]["get"]["parameters"], unknown>;
    /** @summary flush the redis cache (Authorised Roles: SuperUser) */
    getSupportApiFlushRedis: ServiceOperationQuery<{
        method: "get";
        url: "/rest/support/flush-redis";
    }, paths["/rest/support/flush-redis"]["get"]["responses"]["200"]["content"]["text/plain"], undefined, unknown>;
    /** @summary set an arbitrary redis key/value (Authorised Roles: SuperUser) */
    getSupportApiSetRedis: ServiceOperationQuery<{
        method: "get";
        url: "/rest/support/set-redis";
    }, paths["/rest/support/set-redis"]["get"]["responses"]["200"]["content"]["text/plain"], paths["/rest/support/set-redis"]["get"]["parameters"], unknown>;
    /** @summary  (Authorised Roles: SuperUser) */
    getSupportApiListImages: ServiceOperationQuery<{
        method: "get";
        url: "/rest/support/listImages";
    }, paths["/rest/support/listImages"]["get"]["responses"]["200"]["content"]["text/plain"], undefined, unknown>;
    /** @summary  (Authorised Roles: SuperUser) */
    postSupportApiAddImage: ServiceOperationMutation<{
        method: "post";
        url: "/rest/support/addImage";
        mediaType: "multipart/form-data";
    }, NonNullable<paths["/rest/support/addImage"]["post"]["requestBody"]>["content"]["multipart/form-data"], paths["/rest/support/addImage"]["post"]["responses"]["200"]["content"]["text/plain"], undefined, unknown>;
    getSupportApiGetImage: ServiceOperationQuery<{
        method: "get";
        url: "/rest/support/getImage";
    }, paths["/rest/support/getImage"]["get"]["responses"]["200"]["content"]["text/plain"], paths["/rest/support/getImage"]["get"]["parameters"], unknown>;
    /** @summary  (Authorised Roles: SuperUser) */
    deleteSupportApiDeleteImage: ServiceOperationMutation<{
        method: "delete";
        url: "/rest/support/deleteImage";
    }, undefined, paths["/rest/support/deleteImage"]["delete"]["responses"]["200"]["content"]["text/plain"], paths["/rest/support/deleteImage"]["delete"]["parameters"], unknown>;
    /** @summary List file templates for an application / entity type (Authorised Roles: SuperUser, ApplicationAdministrator) */
    getTemplatesApiListFileTemplates: ServiceOperationQuery<{
        method: "get";
        url: "/rest/templates";
    }, paths["/rest/templates"]["get"]["responses"]["200"]["content"]["text/plain"], paths["/rest/templates"]["get"]["parameters"], unknown>;
    /** @summary Adds a new template. (Authorised Roles: SuperUser, ApplicationAdministrator) */
    putTemplatesApiAddTemplate: ServiceOperationMutation<{
        method: "put";
        url: "/rest/templates";
        mediaType: "application/json-patch+json";
    }, NonNullable<paths["/rest/templates"]["put"]["requestBody"]>["content"]["application/json-patch+json"], paths["/rest/templates"]["put"]["responses"]["200"]["content"]["text/plain"], undefined, unknown>;
    /** @summary Updates a template. (Authorised Roles: SuperUser, ApplicationAdministrator) */
    postTemplatesApiUpdateTemplate: ServiceOperationMutation<{
        method: "post";
        url: "/rest/templates";
        mediaType: "application/json-patch+json";
    }, NonNullable<paths["/rest/templates"]["post"]["requestBody"]>["content"]["application/json-patch+json"], paths["/rest/templates"]["post"]["responses"]["200"]["content"]["text/plain"], undefined, unknown>;
    /** @summary Deletes a template. (Authorised Roles: SuperUser, ApplicationAdministrator) */
    deleteTemplatesApiDeleteTemplate: ServiceOperationMutation<{
        method: "delete";
        url: "/rest/templates";
        mediaType: "application/json-patch+json";
    }, NonNullable<paths["/rest/templates"]["delete"]["requestBody"]>["content"]["application/json-patch+json"], paths["/rest/templates"]["delete"]["responses"]["200"]["content"]["text/plain"], undefined, unknown>;
    getTemplatesApiGetTemplateSummary: ServiceOperationQuery<{
        method: "get";
        url: "/rest/templates_summary/{applicationId},{projectId}";
    }, paths["/rest/templates_summary/{applicationId},{projectId}"]["get"]["responses"]["200"]["content"]["text/plain"], paths["/rest/templates_summary/{applicationId},{projectId}"]["get"]["parameters"], unknown>;
    getTemplatesApiGetSpecificTemplateSummary: ServiceOperationQuery<{
        method: "get";
        url: "/rest/templates_activity_log/{applicationId},{projectId},{entityId},{templateId}";
    }, paths["/rest/templates_activity_log/{applicationId},{projectId},{entityId},{templateId}"]["get"]["responses"]["200"]["content"]["text/plain"], paths["/rest/templates_activity_log/{applicationId},{projectId},{entityId},{templateId}"]["get"]["parameters"], unknown>;
    postTemplatesApiPostTransitionUpdate: ServiceOperationMutation<{
        method: "post";
        url: "/rest/templates_activity_log_transition_template";
        mediaType: "multipart/form-data";
    }, NonNullable<paths["/rest/templates_activity_log_transition_template"]["post"]["requestBody"]>["content"]["multipart/form-data"], paths["/rest/templates_activity_log_transition_template"]["post"]["responses"]["200"]["content"]["text/plain"], undefined, unknown>;
    /** @summary Get a menu for the app/user */
    getUiApiGetSupportMenu: ServiceOperationQuery<{
        method: "get";
        url: "/rest/ui/support-menu";
    }, paths["/rest/ui/support-menu"]["get"]["responses"]["200"]["content"]["text/plain"], paths["/rest/ui/support-menu"]["get"]["parameters"], unknown>;
    /** @summary Get pages of an app */
    getUiApiGetPages: ServiceOperationQuery<{
        method: "get";
        url: "/rest/ui/pages/{applicationId}";
    }, paths["/rest/ui/pages/{applicationId}"]["get"]["responses"]["200"]["content"]["text/plain"], paths["/rest/ui/pages/{applicationId}"]["get"]["parameters"], unknown>;
    /** @summary Get roles of an app */
    getUiApiGetRoles: ServiceOperationQuery<{
        method: "get";
        url: "/rest/ui/roles/{applicationId}";
    }, paths["/rest/ui/roles/{applicationId}"]["get"]["responses"]["200"]["content"]["text/plain"], paths["/rest/ui/roles/{applicationId}"]["get"]["parameters"], unknown>;
    /** @summary Gets the config menu of an app */
    getUiApiGetMenu: ServiceOperationQuery<{
        method: "get";
        url: "/rest/ui/menu/{applicationId}/{grouping}";
    }, paths["/rest/ui/menu/{applicationId}/{grouping}"]["get"]["responses"]["200"]["content"]["text/plain"], paths["/rest/ui/menu/{applicationId}/{grouping}"]["get"]["parameters"], unknown>;
    /** @summary Updates the config menu of an app */
    postUiApiUpdateMenu: ServiceOperationMutation<{
        method: "post";
        url: "/rest/ui/menu/{applicationId}/{grouping}";
        mediaType: "application/json-patch+json";
    }, NonNullable<paths["/rest/ui/menu/{applicationId}/{grouping}"]["post"]["requestBody"]>["content"]["application/json-patch+json"], paths["/rest/ui/menu/{applicationId}/{grouping}"]["post"]["responses"]["200"]["content"]["text/plain"], paths["/rest/ui/menu/{applicationId}/{grouping}"]["post"]["parameters"], unknown>;
    /** @summary Gets the cascading filters */
    getUiApiGetFilterGroup: ServiceOperationQuery<{
        method: "get";
        url: "/rest/ui/filter-group/{applicationId}/{projectId}/{filterGroup}";
    }, paths["/rest/ui/filter-group/{applicationId}/{projectId}/{filterGroup}"]["get"]["responses"]["200"]["content"]["text/plain"], paths["/rest/ui/filter-group/{applicationId}/{projectId}/{filterGroup}"]["get"]["parameters"], unknown>;
    /** @summary Sets the cascading filters */
    postUiApiGetFilterGroup: ServiceOperationMutation<{
        method: "post";
        url: "/rest/ui/filter-group/{applicationId}/{projectId}/{filterGroup}";
        mediaType: "application/json-patch+json";
    }, NonNullable<paths["/rest/ui/filter-group/{applicationId}/{projectId}/{filterGroup}"]["post"]["requestBody"]>["content"]["application/json-patch+json"], unknown, paths["/rest/ui/filter-group/{applicationId}/{projectId}/{filterGroup}"]["post"]["parameters"], unknown>;
    /** @summary Gets the applications related to a project */
    getUiApiGetApplicationsByProject: ServiceOperationQuery<{
        method: "get";
        url: "/rest/ui/applications/{projectId}";
    }, paths["/rest/ui/applications/{projectId}"]["get"]["responses"]["200"]["content"]["text/plain"], paths["/rest/ui/applications/{projectId}"]["get"]["parameters"], unknown>;
    /** @summary Retrieves list of assigned workspaces for current user (Authorised Roles: ProjectMember) */
    getWorkspacesApiGetCurrentUserWorkspaces: ServiceOperationQuery<{
        method: "get";
        url: "/rest/workspaces/current";
    }, paths["/rest/workspaces/current"]["get"]["responses"]["200"]["content"]["text/plain"], undefined, unknown>;
    /** @summary Retrieves workspace on app key and project id (Authorised Roles: ProjectMember) */
    getWorkspacesApiGetWorkspace: ServiceOperationQuery<{
        method: "get";
        url: "/rest/workspaces/{appKey}/{projectId}";
    }, paths["/rest/workspaces/{appKey}/{projectId}"]["get"]["responses"]["200"]["content"]["text/plain"], paths["/rest/workspaces/{appKey}/{projectId}"]["get"]["parameters"], unknown>;
    /** @summary  (Authorised Roles: ProjectAdministrator, ProjectLeader, PlatformAdministrator, SuperUser) */
    getWorkspacesApiGetProjectTeamsWorkspace: ServiceOperationQuery<{
        method: "get";
        url: "/rest/workspaces/projectTeam";
    }, paths["/rest/workspaces/projectTeam"]["get"]["responses"]["200"]["content"]["text/plain"], paths["/rest/workspaces/projectTeam"]["get"]["parameters"], unknown>;
    /** @summary  (Authorised Roles: ProjectLeader, PlatformAdministrator, SuperUser) */
    putWorkspacesApiAddProjectTeamToWorkspace: ServiceOperationMutation<{
        method: "put";
        url: "/rest/workspaces/projectTeam";
        mediaType: "application/json-patch+json";
    }, NonNullable<paths["/rest/workspaces/projectTeam"]["put"]["requestBody"]>["content"]["application/json-patch+json"], paths["/rest/workspaces/projectTeam"]["put"]["responses"]["200"]["content"]["text/plain"], undefined, unknown>;
    /** @summary  (Authorised Roles: ProjectLeader, PlatformAdministrator, SuperUser) */
    deleteWorkspacesApiDeleteProjectTeamFromWorkspace: ServiceOperationMutation<{
        method: "delete";
        url: "/rest/workspaces/projectTeam";
        mediaType: "application/json-patch+json";
    }, NonNullable<paths["/rest/workspaces/projectTeam"]["delete"]["requestBody"]>["content"]["application/json-patch+json"], paths["/rest/workspaces/projectTeam"]["delete"]["responses"]["200"]["content"]["text/plain"], undefined, unknown>;
    /** @summary  (Authorised Roles: ProjectAdministrator, ProjectLeader, PlatformAdministrator, SuperUser) */
    getWorkspacesApiGetSupportTeamsWorkspace: ServiceOperationQuery<{
        method: "get";
        url: "/rest/workspaces/supportTeam";
    }, paths["/rest/workspaces/supportTeam"]["get"]["responses"]["200"]["content"]["text/plain"], paths["/rest/workspaces/supportTeam"]["get"]["parameters"], unknown>;
    /** @summary  (Authorised Roles: ProjectLeader, PlatformAdministrator, SuperUser) */
    putWorkspacesApiAddSupportTeamToWorkspace: ServiceOperationMutation<{
        method: "put";
        url: "/rest/workspaces/supportTeam";
        mediaType: "application/json-patch+json";
    }, NonNullable<paths["/rest/workspaces/supportTeam"]["put"]["requestBody"]>["content"]["application/json-patch+json"], paths["/rest/workspaces/supportTeam"]["put"]["responses"]["200"]["content"]["text/plain"], undefined, unknown>;
    /** @summary  (Authorised Roles: ProjectLeader, PlatformAdministrator, SuperUser) */
    deleteWorkspacesApiDeleteSupportTeamFromWorkspace: ServiceOperationMutation<{
        method: "delete";
        url: "/rest/workspaces/supportTeam";
        mediaType: "application/json-patch+json";
    }, NonNullable<paths["/rest/workspaces/supportTeam"]["delete"]["requestBody"]>["content"]["application/json-patch+json"], paths["/rest/workspaces/supportTeam"]["delete"]["responses"]["200"]["content"]["text/plain"], undefined, unknown>;
    /** @summary  (Authorised Roles: ProjectAdministrator, ProjectLeader, PlatformAdministrator, SuperUser) */
    getWorkspacesApiGetOrganisationWorkspaceEntities: ServiceOperationQuery<{
        method: "get";
        url: "/rest/workspaces/entities";
    }, paths["/rest/workspaces/entities"]["get"]["responses"]["200"]["content"]["text/plain"], paths["/rest/workspaces/entities"]["get"]["parameters"], unknown>;
    /** @summary  (Authorised Roles: ProjectAdministrator, ProjectLeader, PlatformAdministrator, SuperUser) */
    postWorkspacesApiUpdateEntity: ServiceOperationMutation<{
        method: "post";
        url: "/rest/workspaces/entities";
        mediaType: "application/json-patch+json";
    }, NonNullable<paths["/rest/workspaces/entities"]["post"]["requestBody"]>["content"]["application/json-patch+json"], paths["/rest/workspaces/entities"]["post"]["responses"]["200"]["content"]["text/plain"], undefined, unknown>;
    /** @summary  (Authorised Roles: ProjectAdministrator, ProjectLeader, PlatformAdministrator, SuperUser) */
    deleteWorkspacesApiDeleteEntity: ServiceOperationMutation<{
        method: "delete";
        url: "/rest/workspaces/entities";
    }, undefined, paths["/rest/workspaces/entities"]["delete"]["responses"]["200"]["content"]["text/plain"], paths["/rest/workspaces/entities"]["delete"]["parameters"], unknown>;
    /** @summary  (Authorised Roles: ProjectAdministrator, ProjectLeader, PlatformAdministrator, SuperUser) */
    deleteWorkspacesApiDeleteEntityFiles: ServiceOperationMutation<{
        method: "delete";
        url: "/rest/workspaces/entities/files";
    }, undefined, paths["/rest/workspaces/entities/files"]["delete"]["responses"]["200"]["content"]["text/plain"], paths["/rest/workspaces/entities/files"]["delete"]["parameters"], unknown>;
    /** @summary  (Authorised Roles: ProjectAdministrator, ProjectLeader, PlatformAdministrator, SuperUser) */
    getWorkspacesApiGetUsers: ServiceOperationQuery<{
        method: "get";
        url: "/rest/workspaces/users";
    }, paths["/rest/workspaces/users"]["get"]["responses"]["200"]["content"]["text/plain"], paths["/rest/workspaces/users"]["get"]["parameters"], unknown>;
    /** @summary  (Authorised Roles: ProjectLeader, PlatformAdministrator, SuperUser) */
    getWorkspacesApiGetWorkspaceAuditDetails: ServiceOperationQuery<{
        method: "get";
        url: "/rest/workspaces/{workspaceId}/audit";
    }, paths["/rest/workspaces/{workspaceId}/audit"]["get"]["responses"]["200"]["content"]["text/plain"], paths["/rest/workspaces/{workspaceId}/audit"]["get"]["parameters"], unknown>;
    /** @summary  (Authorised Roles: ProjectAdministrator, ProjectLeader, PlatformAdministrator, SuperUser) */
    getWorkspacesApiGetWorkspaceUsers: ServiceOperationQuery<{
        method: "get";
        url: "/rest/workspaces/{workspaceId}/users";
    }, paths["/rest/workspaces/{workspaceId}/users"]["get"]["responses"]["200"]["content"]["text/plain"], paths["/rest/workspaces/{workspaceId}/users"]["get"]["parameters"], unknown>;
    /** @summary  (Authorised Roles: ProjectLeader, PlatformAdministrator, SuperUser) */
    getWorkspacesApiAddApprovedWorkspaceUsersAudit: ServiceOperationQuery<{
        method: "get";
        url: "/rest/workspaces/workspaceUserAudits";
        mediaType: "application/json-patch+json";
    }, paths["/rest/workspaces/workspaceUserAudits"]["get"]["responses"]["200"]["content"]["text/plain"], undefined, unknown>;
    /** @summary  (Authorised Roles: ProjectLeader, PlatformAdministrator, SuperUser) */
    postWorkspacesApiAddApprovedWorkspaceUsersAudit: ServiceOperationMutation<{
        method: "post";
        url: "/rest/workspaces/workspaceUserAudits";
        mediaType: "application/json-patch+json";
    }, NonNullable<paths["/rest/workspaces/workspaceUserAudits"]["post"]["requestBody"]>["content"]["application/json-patch+json"], paths["/rest/workspaces/workspaceUserAudits"]["post"]["responses"]["200"]["content"]["text/plain"], undefined, unknown>;
}
export const restService: {
    /**
     * @deprecated
     * @summary Logs that a user is logged into the DMP application. No params as the token is already in the headers.
     */
    postActivityLoggingApiLogLogin: {
        schema: {
            method: "post";
            url: "/rest/login";
        };
    };
    /** @summary Logs that a user access an application and accepted the terms and conditions and privacy policies. */
    postActivityLoggingApiLogAppAccess: {
        schema: {
            method: "post";
            url: "/rest/app-access";
        };
    };
    /** @summary Gets a list of all applications (Authorised Roles: ProjectMember, ProjectAdministrator, ProjectLeader, PlatformAdministrator, SuperUser, ApplicationAdministrator) */
    getApplicationsApiGetApplications: {
        schema: {
            method: "get";
            url: "/rest/applications/list";
        };
    };
    /** @summary Creates a new application (Authorised Roles: SuperUser) */
    putApplicationsApiAddApplication: {
        schema: {
            method: "put";
            url: "/rest/applications/application";
            mediaType: "application/json-patch+json";
        };
    };
    /** @summary Updates an existing application (Authorised Roles: SuperUser, ApplicationAdministrator) */
    postApplicationsApiUpdateApplication: {
        schema: {
            method: "post";
            url: "/rest/applications/application";
            mediaType: "application/json-patch+json";
        };
    };
    /** @summary Lists an applications current admins (Authorised Roles: SuperUser, ApplicationAdministrator) */
    getApplicationsApiListApplicationAdmins: {
        schema: {
            method: "get";
            url: "/rest/applications/admins";
        };
    };
    /** @summary Makes a user administrator of an application (Authorised Roles: SuperUser) */
    putApplicationsApiAddApplicationAdmin: {
        schema: {
            method: "put";
            url: "/rest/applications/admins";
        };
    };
    /** @summary Removes a users access to administer an application (Authorised Roles: SuperUser) */
    deleteApplicationsApiRemoveApplicationAdmin: {
        schema: {
            method: "delete";
            url: "/rest/applications/admins";
        };
    };
    /** @summary Lists any available application admins (Authorised Roles: SuperUser, ApplicationAdministrator) */
    getApplicationsApiListAllAdmins: {
        schema: {
            method: "get";
            url: "/rest/applications/admins/all";
        };
    };
    /** @summary Get a list of roles for an application (Authorised Roles: ProjectAdministrator, ProjectLeader, SuperUser, ApplicationAdministrator) */
    getApplicationsApiListApplicationRoles: {
        schema: {
            method: "get";
            url: "/rest/applications/roles";
        };
    };
    /** @summary Add a role for an application (Authorised Roles: SuperUser, ApplicationAdministrator) */
    putApplicationsApiAddApplicationRole: {
        schema: {
            method: "put";
            url: "/rest/applications/roles";
            mediaType: "application/json-patch+json";
        };
    };
    /** @summary Update a role for an application (Authorised Roles: SuperUser, ApplicationAdministrator) */
    postApplicationsApiUpdateApplicationRole: {
        schema: {
            method: "post";
            url: "/rest/applications/roles";
            mediaType: "application/json-patch+json";
        };
    };
    /** @summary Get marketing attributes for an application (Authorised Roles: SuperUser, ApplicationAdministrator) */
    getApplicationsApiGetApplicationAttributes: {
        schema: {
            method: "get";
            url: "/rest/applications/attribs";
        };
    };
    /** @summary Update marketing attributes for an application (Authorised Roles: SuperUser, ApplicationAdministrator) */
    postApplicationsApiUpdateApplicationAttributes: {
        schema: {
            method: "post";
            url: "/rest/applications/attribs";
            mediaType: "application/json-patch+json";
        };
    };
    /** @summary Retrieves the list of application support teams for the current user's organization. (Authorised Roles: ProjectAdministrator, ProjectLeader, PlatformAdministrator, SuperUser) */
    getApplicationsApiGetApplicationTeamsForUserOrganization: {
        schema: {
            method: "get";
            url: "/rest/applications/teams/{appId}";
        };
    };
    /** @summary Retrieves the list of application teams for a given organization. (Authorised Roles: ProjectAdministrator, ProjectLeader, PlatformAdministrator, SuperUser) */
    getApplicationsApiGetApplicationTeams: {
        schema: {
            method: "get";
            url: "/rest/applications/teams";
        };
    };
    /** @summary Gets Application support team users for the current user's Organization. (Authorised Roles: ProjectAdministrator, ProjectLeader, PlatformAdministrator, SuperUser) */
    getApplicationsApiGetApplicationSupportTeamUsersForOrg: {
        schema: {
            method: "get";
            url: "/rest/applications/teams/support/{appId}";
        };
    };
    /** @summary Adds a new team to the application. (Authorised Roles: PlatformAdministrator, SuperUser, ApplicationAdministrator) */
    putApplicationsApiAddTeam: {
        schema: {
            method: "put";
            url: "/rest/applications/teams/support";
            mediaType: "application/json-patch+json";
        };
    };
    /** @summary Updates an application team (Authorised Roles: PlatformAdministrator, SuperUser, ApplicationAdministrator) */
    postApplicationsApiUpdateTeam: {
        schema: {
            method: "post";
            url: "/rest/applications/teams/support";
            mediaType: "application/json-patch+json";
        };
    };
    /** @summary Gets a list of all image/pictogram keys for use when editing image attributes (Authorised Roles: SuperUser, ApplicationAdministrator) */
    getApplicationsApiGetPictograms: {
        schema: {
            method: "get";
            url: "/rest/applications/pictograms";
        };
    };
    /** @summary Gets a list of all users for use when editing application attributes key contacts (Authorised Roles: SuperUser, ApplicationAdministrator) */
    getApplicationsApiGetUsers: {
        schema: {
            method: "get";
            url: "/rest/applications/users";
        };
    };
    /** @summary Gets a list of all accesses for an application (Authorised Roles: SuperUser, ApplicationAdministrator) */
    getApplicationsApiGetAccesses: {
        schema: {
            method: "get";
            url: "/rest/applications/accesses";
        };
    };
    /** @summary Sets the accesses for a role for an application. (Authorised Roles: SuperUser, ApplicationAdministrator) */
    postApplicationsApiSetAccesses: {
        schema: {
            method: "post";
            url: "/rest/applications/accesses";
            mediaType: "application/json-patch+json";
        };
    };
    /** @summary Gets a list of all entity types for an application (Authorised Roles: SuperUser, ApplicationAdministrator) */
    getApplicationsApiGetEntityTypes: {
        schema: {
            method: "get";
            url: "/rest/applications/entityTypes";
        };
    };
    /** @summary Adds a data asset permission (Authorised Roles: PlatformAdministrator, SuperUser, ApplicationAdministrator) */
    putApplicationsApiAddDataAssetPermission: {
        schema: {
            method: "put";
            url: "/rest/applications/data-assets";
            mediaType: "application/json-patch+json";
        };
    };
    /** @summary Updates a data asset permission (Authorised Roles: PlatformAdministrator, SuperUser, ApplicationAdministrator) */
    postApplicationsApiUpdateDataAssetPermission: {
        schema: {
            method: "post";
            url: "/rest/applications/data-assets";
            mediaType: "application/json-patch+json";
        };
    };
    /** @summary Deletes a data asset permission (Authorised Roles: PlatformAdministrator, SuperUser, ApplicationAdministrator) */
    deleteApplicationsApiDeleteDataAssetPermission: {
        schema: {
            method: "delete";
            url: "/rest/applications/data-assets";
        };
    };
    /** @summary Adds a file template role (Authorised Roles: PlatformAdministrator, SuperUser, ApplicationAdministrator) */
    putApplicationsApiAddFileTemplateRole: {
        schema: {
            method: "put";
            url: "/rest/applications/file-templates";
            mediaType: "application/json-patch+json";
        };
    };
    /** @summary Updates the permissions on a file template role. (Authorised Roles: PlatformAdministrator, SuperUser, ApplicationAdministrator) */
    postApplicationsApiUpdateFileTemplateRole: {
        schema: {
            method: "post";
            url: "/rest/applications/file-templates";
            mediaType: "application/json-patch+json";
        };
    };
    /** @summary Deletes a file template role. (Authorised Roles: PlatformAdministrator, SuperUser, ApplicationAdministrator) */
    deleteApplicationsApiDeleteFileTemplateRole: {
        schema: {
            method: "delete";
            url: "/rest/applications/file-templates";
        };
    };
    /** @summary  (Authorised Roles: SuperUser, ApplicationAdministrator) */
    getApplicationsApiGetRolePermissions: {
        schema: {
            method: "get";
            url: "/rest/applications/roles/permissions";
        };
    };
    /** @summary Get an apps settings (json response) */
    getAppSettingsApiGetAppSettings: {
        schema: {
            method: "get";
            url: "/rest/app-settings/{applicationId}";
        };
    };
    /** @summary Get an apps settings as downloadable json file */
    getAppSettingsApiGetAppSettingsDownloadFile: {
        schema: {
            method: "get";
            url: "/rest/app-settings/download/{applicationId}";
        };
    };
    /**
     * @summary Upload an App Settings (Export) file to be imported into this environment.
     * File will automatically be checked to see what differences there are between the file and this environment (Authorised Roles: SuperUser, ApplicationAdministrator)
     */
    postAppSettingsApiAppSettingsUpload: {
        schema: {
            method: "post";
            url: "/rest/app-settings/upload";
            mediaType: "multipart/form-data";
        };
    };
    /** @summary Gets a list of previously uploaded app settings files */
    getAppSettingsApiGetAppSettingsUploads: {
        schema: {
            method: "get";
            url: "/rest/app-settings-upload";
        };
    };
    /** @summary Gets a specific app settings upload */
    getAppSettingsApiGetAppSettingsUpload: {
        schema: {
            method: "get";
            url: "/rest/app-settings-upload/{appSettingsUploadId}";
        };
    };
    /** @summary You can patch an app-settings-upload with a new status and an ApplyRequest to apply it (Authorised Roles: SuperUser, ApplicationAdministrator) */
    patchAppSettingsApiGetAppSettingsUpload: {
        schema: {
            method: "patch";
            url: "/rest/app-settings-upload/{appSettingsUploadId}";
            mediaType: "application/json-patch+json";
        };
    };
    /** @summary Logs a user into the DMP application by using the code returned to the front end by the PwC identity service and returns a jwt token */
    postAuthenticationApiGetToken: {
        schema: {
            method: "post";
            url: "/rest/getToken";
        };
    };
    /** @summary Logs a user out by removing their token from cache and adding to blacklist */
    postAuthenticationApiLogout: {
        schema: {
            method: "post";
            url: "/rest/logout";
        };
    };
    /** @summary Logs out another user by their userId */
    postAuthenticationApiLogoutUser: {
        schema: {
            method: "post";
            url: "/rest/logout/{userId}";
        };
    };
    postCatalogApiRegisterApplication: {
        schema: {
            method: "post";
            url: "/rest/catalog/register";
            mediaType: "application/json-patch+json";
        };
    };
    postCatalogApiContentHandler: {
        schema: {
            method: "post";
            url: "/rest/catalog/handler/content";
            mediaType: "application/json-patch+json";
        };
    };
    /** @summary Get all chats for an application (Authorised Roles: SuperUser, ApplicationAdministrator) */
    getChatApiGetChat: {
        schema: {
            method: "get";
            url: "/rest/chat/{applicationId}";
        };
    };
    /** @summary Add a new chat on an application (Authorised Roles: SuperUser, ApplicationAdministrator) */
    putChatApiAddChat: {
        schema: {
            method: "put";
            url: "/rest/chat/{applicationId}";
            mediaType: "application/json-patch+json";
        };
    };
    /** @summary Update a chat */
    postChatApiPostChat: {
        schema: {
            method: "post";
            url: "/rest/chat/{applicationId}";
            mediaType: "application/json-patch+json";
        };
    };
    /** @summary Get a single chat (Authorised Roles: SuperUser, ApplicationAdministrator) */
    getChatApiGetChatItem: {
        schema: {
            method: "get";
            url: "/rest/chat/{applicationId}/{chatId}";
        };
    };
    /** @summary Adds a new data asset. (Authorised Roles: SuperUser, ApplicationAdministrator) */
    putDataAssetApiAddDataAsset: {
        schema: {
            method: "put";
            url: "/rest/data_asset";
            mediaType: "application/json-patch+json";
        };
    };
    /** @summary Updates a data asset. (Authorised Roles: SuperUser, ApplicationAdministrator) */
    postDataAssetApiUpdateTemplate: {
        schema: {
            method: "post";
            url: "/rest/data_asset";
            mediaType: "application/json-patch+json";
        };
    };
    /** @summary Deletes a data asset. (Authorised Roles: SuperUser, ApplicationAdministrator) */
    deleteDataAssetApiDeleteTemplate: {
        schema: {
            method: "delete";
            url: "/rest/data_asset";
            mediaType: "application/json-patch+json";
        };
    };
    /** @summary List data assets for an application / entity type (Authorised Roles: SuperUser, ApplicationAdministrator) */
    getDataAssetApiListDataAssets: {
        schema: {
            method: "get";
            url: "/rest/data_asset";
        };
    };
    /** @summary Gets the summary of data assets for a specific application and project. */
    getDataAssetApiGetTemplateSummary: {
        schema: {
            method: "get";
            url: "/rest/data_asset/summary/{applicationId},{projectId}";
        };
    };
    /** @summary Gets the activity log of a specific data asset. */
    getDataAssetApiGetSpecificDataAssetSummary: {
        schema: {
            method: "get";
            url: "/rest/data_asset/activity_log/{applicationId},{projectId},{entityId},{dataAssetId}";
        };
    };
    /** @summary Updates the state of a data asset. */
    postDataAssetApiPostTransitionUpdate: {
        schema: {
            method: "post";
            url: "/rest/data_asset/transition";
            mediaType: "multipart/form-data";
        };
    };
    /** @summary Checks that Databricks instance is accessible and configured correctly (Authorised Roles: PlatformAdministrator, SuperUser, ApplicationAdministrator) */
    getDatabricksApiGetDatabricksStatus: {
        schema: {
            method: "get";
            url: "/rest/databricks/connection";
        };
    };
    /** @summary Initialise Databricks environment. Creates user groups, compute policy, compute clusters, permissions, unity catalog (Authorised Roles: SuperUser) */
    putDatabricksApiInitialiseDatabricks: {
        schema: {
            method: "put";
            url: "/rest/databricks/connection";
        };
    };
    /** @summary Checks that Databricks enabled application has then necessary parts configured in Databricks (Authorised Roles: PlatformAdministrator, SuperUser, ApplicationAdministrator) */
    getDatabricksApiGetDatabricksApplicationStatus: {
        schema: {
            method: "get";
            url: "/rest/databricks/application";
        };
    };
    /** @summary Provisions a Databricks enabled application on Databricks. Creates development application folder, developer group, cross-development schema, development schemas, and assigns permissions to folder/compute/catalogs (Authorised Roles: SuperUser, ApplicationAdministrator) */
    putDatabricksApiProvisionApplication: {
        schema: {
            method: "put";
            url: "/rest/databricks/application";
        };
    };
    /**
     * @summary Promotes a Databricks enabled application on Databricks.
     * Deletes existing production folder if it exists.
     * Creates production application folder, developer group, cross-development schema, development schemas, and assigns permissions to folder/compute/catalogs.
     * Copies notebooks, cross client data (volumes) from development to production folder. (Authorised Roles: SuperUser, ApplicationAdministrator)
     */
    postDatabricksApiPromoteApplication: {
        schema: {
            method: "post";
            url: "/rest/databricks/application/promote";
        };
    };
    /** @summary Adds a new template notebook/.ipynb to a Databricks application, to be used as the template for all workspaces (Authorised Roles: SuperUser, ApplicationAdministrator) */
    putDatabricksApiAddDefaultApplicationNotebook: {
        schema: {
            method: "put";
            url: "/rest/databricks/application/notebooks";
        };
    };
    /** @summary Adds a notebook/.ipynb to a Databricks application, to be used as the template for all workspaces (Authorised Roles: SuperUser, ApplicationAdministrator) */
    postDatabricksApiAddApplicationNotebook: {
        schema: {
            method: "post";
            url: "/rest/databricks/application/notebooks";
            mediaType: "multipart/form-data";
        };
    };
    /** @summary Checks the current status of a Databricks workspace linked to a Databricks enabled application (Authorised Roles: ProjectAdministrator, ProjectLeader, PlatformAdministrator, SuperUser, ApplicationAdministrator) */
    getDatabricksApiGetDatabricksWorkspaceStatus: {
        schema: {
            method: "get";
            url: "/rest/databricks/workspace";
        };
    };
    /** @summary Sets up Databricks for new workspace. Creates service principal, grants access, creates result reader group, workspace catalog and workspace job run (Authorised Roles: ProjectAdministrator, ProjectLeader, PlatformAdministrator, SuperUser, ApplicationAdministrator) */
    putDatabricksApiCreateDatabricksWorkspace: {
        schema: {
            method: "put";
            url: "/rest/databricks/workspace";
        };
    };
    /** @summary Syncs Jobs with the Production notebooks (Authorised Roles: PlatformAdministrator, SuperUser, ApplicationAdministrator) */
    putDatabricksApiSyncDatabricksWorkspaceJobs: {
        schema: {
            method: "put";
            url: "/rest/databricks/workspace/jobs/sync";
        };
    };
    /** @summary Runs a Job with the Production notebook (Authorised Roles: PlatformAdministrator, SuperUser, ApplicationAdministrator) */
    putDatabricksApiRunDatabricksWorkspaceJobs: {
        schema: {
            method: "put";
            url: "/rest/databricks/workspace/jobs/run";
        };
    };
    /** @summary Gets a PowerBi datasource file (.pbids) configured to connect to the Databricks instance using a particular users credentials (Authorised Roles: ProjectAdministrator, ProjectLeader, PlatformAdministrator, SuperUser, ApplicationAdministrator) */
    getDatabricksApiGetDatabricksWorkspacePowerBi: {
        schema: {
            method: "get";
            url: "/rest/databricks/workspace/powerbi";
        };
    };
    /** @summary Creates an entityType based on ApplicationId, name, and description. (Authorised Roles: SuperUser, ApplicationAdministrator) */
    postEntityTypeApiCreateEntityType: {
        schema: {
            method: "post";
            url: "/rest/entitytypes/entityType";
            mediaType: "application/json-patch+json";
        };
    };
    /** @summary Updates an existing entityType based on its ID contained in the request. (Authorised Roles: SuperUser, ApplicationAdministrator) */
    putEntityTypeApiUpdateEntityType: {
        schema: {
            method: "put";
            url: "/rest/entitytypes/entityType";
            mediaType: "application/json-patch+json";
        };
    };
    /** @summary Returns all entity types for an application */
    getEntityTypeApiGetEntityTypesByApplicationId: {
        schema: {
            method: "get";
            url: "/rest/entitytypes/application/{applicationId}";
        };
    };
    /** @summary  (Authorised Roles: SuperUser, ApplicationAdministrator) */
    deleteEntityTypeApiDeleteEntityType: {
        schema: {
            method: "delete";
            url: "/rest/entitytypes/{id}";
        };
    };
    /** @summary Get a whole collection of questions for an application */
    getFaqApiGetFaq: {
        schema: {
            method: "get";
            url: "/rest/faq/{applicationId}";
        };
    };
    /** @summary PUT a new question on an application */
    putFaqApiAddFaq: {
        schema: {
            method: "put";
            url: "/rest/faq/{applicationId}";
            mediaType: "application/json-patch+json";
        };
    };
    /** @summary POST a whole Faq to update the entire collection, eg. for sort orders */
    postFaqApiPostFaq: {
        schema: {
            method: "post";
            url: "/rest/faq/{applicationId}";
            mediaType: "application/json-patch+json";
        };
    };
    /** @summary Get a single question in an application */
    getFaqApiGetFaqItem: {
        schema: {
            method: "get";
            url: "/rest/faq/{applicationId}/{questionId}";
        };
    };
    /** @summary Update a single question in an application */
    patchFaqApiUpdateFaqItem: {
        schema: {
            method: "patch";
            url: "/rest/faq/{applicationId}/{questionId}";
            mediaType: "application/json-patch+json";
        };
    };
    /** @summary Delete a single question in an application */
    deleteFaqApiDeleteFaqItem: {
        schema: {
            method: "delete";
            url: "/rest/faq/{applicationId}/{questionId}";
        };
    };
    /** @summary Get a whole collection of terms for an application */
    getGlossaryApiGetGlossary: {
        schema: {
            method: "get";
            url: "/rest/glossary/{applicationId}";
        };
    };
    /** @summary PUT a new term on an application */
    putGlossaryApiAddGlossary: {
        schema: {
            method: "put";
            url: "/rest/glossary/{applicationId}";
            mediaType: "application/json-patch+json";
        };
    };
    /** @summary POST a whole glossary to update the entire collection, eg. for sort orders */
    postGlossaryApiPostGlossary: {
        schema: {
            method: "post";
            url: "/rest/glossary/{applicationId}";
            mediaType: "application/json-patch+json";
        };
    };
    /** @summary Get a single term in an application */
    getGlossaryApiGetGlossaryItem: {
        schema: {
            method: "get";
            url: "/rest/glossary/{applicationId}/{termId}";
        };
    };
    /** @summary Update a single term in an application */
    patchGlossaryApiUpdateGlossaryItem: {
        schema: {
            method: "patch";
            url: "/rest/glossary/{applicationId}/{termId}";
            mediaType: "application/json-patch+json";
        };
    };
    /** @summary Delete a single term in an application */
    deleteGlossaryApiDeleteGlossaryItem: {
        schema: {
            method: "delete";
            url: "/rest/glossary/{applicationId}/{termId}";
        };
    };
    getLandingApiGetApplicationExternal: {
        schema: {
            method: "get";
            url: "/rest/application_external";
        };
    };
    getLandingApiGetApplicationInfoExternal: {
        schema: {
            method: "get";
            url: "/rest/application_info_external/{applicationId}";
        };
    };
    getLandingApiGetPlatformExternal: {
        schema: {
            method: "get";
            url: "/rest/platform_external";
        };
    };
    /** @summary  (Authorised Roles: ProjectMember) */
    getLandingApiGetApplicationProjects: {
        schema: {
            method: "get";
            url: "/rest/application_projects";
        };
    };
    /** @summary  (Authorised Roles: ProjectMember) */
    getLandingApiGetProjects: {
        schema: {
            method: "get";
            url: "/rest/projects";
        };
    };
    /** @summary  (Authorised Roles: ProjectMember) */
    getLandingApiGetApplications: {
        schema: {
            method: "get";
            url: "/rest/applications";
        };
    };
    /** @summary  (Authorised Roles: ProjectMember) */
    getLandingApiGetPlatformOperations: {
        schema: {
            method: "get";
            url: "/rest/platform";
        };
    };
    /** @summary Get all pipelines for an application (Authorised Roles: SuperUser, ApplicationAdministrator) */
    getPipelineApiGetPipeline: {
        schema: {
            method: "get";
            url: "/rest/pipeline/{applicationId}";
        };
    };
    /** @summary Add a new pipeline on an application (Authorised Roles: SuperUser, ApplicationAdministrator) */
    putPipelineApiAddPipeline: {
        schema: {
            method: "put";
            url: "/rest/pipeline/{applicationId}";
            mediaType: "application/json-patch+json";
        };
    };
    /** @summary Update a pipeline */
    postPipelineApiPostPipeline: {
        schema: {
            method: "post";
            url: "/rest/pipeline/{applicationId}";
            mediaType: "application/json-patch+json";
        };
    };
    /** @summary Get a single pipeline (Authorised Roles: SuperUser, ApplicationAdministrator) */
    getPipelineApiGetPipelineItem: {
        schema: {
            method: "get";
            url: "/rest/pipeline/{applicationId}/{pipelineId}";
        };
    };
    /** @summary  (Authorised Roles: ProjectLeader, PlatformAdministrator, SuperUser) */
    getProjectsApiGetUsers: {
        schema: {
            method: "get";
            url: "/rest/projects/users";
        };
    };
    /** @summary  (Authorised Roles: ProjectAdministrator, ProjectLeader, PlatformAdministrator, SuperUser) */
    putProjectsApiAddUserToProject: {
        schema: {
            method: "put";
            url: "/rest/projects/users";
            mediaType: "application/json-patch+json";
        };
    };
    /** @summary  (Authorised Roles: ProjectAdministrator, ProjectLeader, PlatformAdministrator, SuperUser) */
    deleteProjectsApiRemoveUserFromProject: {
        schema: {
            method: "delete";
            url: "/rest/projects/users";
            mediaType: "application/json-patch+json";
        };
    };
    /** @summary  (Authorised Roles: ProjectAdministrator, ProjectLeader, PlatformAdministrator, SuperUser) */
    putProjectsApiUpdateUserFromProject: {
        schema: {
            method: "put";
            url: "/rest/projects/users/update";
            mediaType: "application/json-patch+json";
        };
    };
    /** @summary Lists all projects in an organisation. (Authorised Roles: ProjectAdministrator, ProjectLeader, PlatformAdministrator, SuperUser) */
    getProjectsApiListOrganisationProjects: {
        schema: {
            method: "get";
            url: "/rest/projects/organisation/projects";
        };
    };
    /** @summary Adds a new project to an organisation. (Authorised Roles: ProjectLeader, PlatformAdministrator, SuperUser) */
    putProjectsApiAddProject: {
        schema: {
            method: "put";
            url: "/rest/projects/organisation/projects";
            mediaType: "application/json-patch+json";
        };
    };
    /** @summary Updates an existing project within an organisation. (Authorised Roles: ProjectLeader, PlatformAdministrator, SuperUser) */
    postProjectsApiUpdateProject: {
        schema: {
            method: "post";
            url: "/rest/projects/organisation/projects";
            mediaType: "application/json-patch+json";
        };
    };
    /** @summary Freezes a project, making it read-only. (Authorised Roles: PlatformAdministrator, SuperUser) */
    postProjectsApiFreezeProject: {
        schema: {
            method: "post";
            url: "/rest/projects/organisation/projects/freeze";
            mediaType: "application/json-patch+json";
        };
    };
    /** @summary Unfreezes a project, making it editable again. (Authorised Roles: SuperUser) */
    postProjectsApiUnfreezeProject: {
        schema: {
            method: "post";
            url: "/rest/projects/organisation/projects/unfreeze";
            mediaType: "application/json-patch+json";
        };
    };
    /** @summary Adds a new administrator to a project. (Authorised Roles: ProjectLeader, PlatformAdministrator, SuperUser) */
    putProjectsApiAddProjectAdmin: {
        schema: {
            method: "put";
            url: "/rest/projects/organisation/projects/admins";
        };
    };
    /** @summary Removes an administrator from a project. (Authorised Roles: ProjectLeader, PlatformAdministrator, SuperUser) */
    deleteProjectsApiRemoveProjectAdmin: {
        schema: {
            method: "delete";
            url: "/rest/projects/organisation/projects/admins";
        };
    };
    /** @summary Adds a new leader to a project. (Authorised Roles: PlatformAdministrator, SuperUser) */
    putProjectsApiAddProjectLeader: {
        schema: {
            method: "put";
            url: "/rest/projects/organisation/projects/leaders";
        };
    };
    /** @summary Removes a leader from a project. (Authorised Roles: PlatformAdministrator, SuperUser) */
    deleteProjectsApiRemoveProjectLeader: {
        schema: {
            method: "delete";
            url: "/rest/projects/organisation/projects/leaders";
        };
    };
    postStorageApiStorageFileRequirements: {
        schema: {
            method: "post";
            url: "/rest/storage/fileRequirements";
        };
    };
    /** @summary  (Authorised Roles: ProjectMember) */
    postStorageApiUploadFile: {
        schema: {
            method: "post";
            url: "/rest/storage/upload_file";
            mediaType: "multipart/form-data";
        };
    };
    /** @summary  (Authorised Roles: ProjectMember) */
    getStorageApiDownloadFile: {
        schema: {
            method: "get";
            url: "/rest/storage/download_file/{blobName},{applicationId},{projectId},{fileType}";
        };
    };
    /** @summary  (Authorised Roles: ProjectMember, ProjectAdministrator, ProjectLeader, SuperUser) */
    getStorageApiDownloadFileWorkspace: {
        schema: {
            method: "get";
            url: "/rest/storage/download_file/workspace";
        };
    };
    /** @summary Get a summary of storage/files, including counts per type (Authorised Roles: ProjectMember, ProjectAdministrator, ProjectLeader, SuperUser) */
    getStorageApiGetFilesSummary: {
        schema: {
            method: "get";
            url: "/rest/storage/summary/{applicationId},{projectId}";
        };
    };
    /** @summary Get a detailed list of files for a type, including filename, size, current indicator (Authorised Roles: ProjectMember, ProjectAdministrator, ProjectLeader, SuperUser) */
    getStorageApiGetFilesDetails: {
        schema: {
            method: "get";
            url: "/rest/storage/details/{applicationId},{projectId},{type}";
        };
    };
    /** @summary Get a detailed list of files for a workspace, including filename, size, current indicator (Authorised Roles: ProjectMember, ProjectAdministrator, ProjectLeader, SuperUser) */
    getStorageApiGetFilesDetailsWorkspace: {
        schema: {
            method: "get";
            url: "/rest/storage/details/workspace";
        };
    };
    /** @summary Get a detailed list of files for an entity, including filename, size, current indicator (Authorised Roles: ProjectMember, ProjectAdministrator, ProjectLeader, SuperUser) */
    getStorageApiGetFilesDetailsEntityTemplates: {
        schema: {
            method: "get";
            url: "/rest/storage/details/entityTemplates";
        };
    };
    /** @summary Get a detailed list of files for an entity, including filename, size (Authorised Roles: ProjectMember, ProjectAdministrator, ProjectLeader, SuperUser) */
    getStorageApiGetFilesDetailsEntityDataAssets: {
        schema: {
            method: "get";
            url: "/rest/storage/details/entityDataAssets";
        };
    };
    /** @summary Deletes all files of a particular type (for project/application) (Authorised Roles: ProjectAdministrator, ProjectLeader, SuperUser) */
    getStorageApiDeleteAll: {
        schema: {
            method: "get";
            url: "/rest/storage/delete-all/{applicationId},{projectId},{type}";
        };
    };
    /**
     * @summary Deletes all "unused" files of a particular type (for project/application)
     * eg. old template uploads (Authorised Roles: ProjectAdministrator, ProjectLeader, SuperUser)
     */
    getStorageApiDeleteUnused: {
        schema: {
            method: "get";
            url: "/rest/storage/delete-unused/{applicationId},{projectId},{type}";
        };
    };
    /** @summary  (Authorised Roles: ProjectMember, ProjectAdministrator, ProjectLeader, SuperUser) */
    postStorageApiDeleteFileWorkspace: {
        schema: {
            method: "post";
            url: "/rest/storage/delete_file/workspace";
        };
    };
    /**
     * @summary Migrates files for a project/application from the old storage format to the new storage format
     * Old: All files as blobs in a single container
     * New: Files structured in "folders" (Authorised Roles: ProjectAdministrator, ProjectLeader, SuperUser)
     */
    getStorageApiMigrate: {
        schema: {
            method: "get";
            url: "/rest/storage/migrate/{applicationId},{projectId},{apply}";
        };
    };
    /** @summary Gets details of job busy being applied (Authorised Roles: ProjectAdministrator, ProjectLeader, SuperUser) */
    getStorageApiGetMigrationJob: {
        schema: {
            method: "get";
            url: "/rest/storage/migrate/{applicationId},{projectId},{jobId}";
        };
    };
    /** @summary  (Authorised Roles: ProjectAdministrator, ProjectLeader, PlatformAdministrator, SuperUser) */
    getSubscriptionsApiGetOrganisation: {
        schema: {
            method: "get";
            url: "/rest/subscriptions/organisation";
        };
    };
    /** @summary Adds a new organisation. (Authorised Roles: SuperUser) */
    putSubscriptionsApiAddOrganisation: {
        schema: {
            method: "put";
            url: "/rest/subscriptions/organisation";
            mediaType: "application/json-patch+json";
        };
    };
    /** @summary Updates an existing organisation. (Authorised Roles: PlatformAdministrator, SuperUser) */
    postSubscriptionsApiUpdateOrganisation: {
        schema: {
            method: "post";
            url: "/rest/subscriptions/organisation";
            mediaType: "application/json-patch+json";
        };
    };
    /** @summary Retrieves the list of organisations. (Authorised Roles: ProjectMember, ProjectAdministrator, ProjectLeader, PlatformAdministrator, SuperUser) */
    getSubscriptionsApiGetOrganisations: {
        schema: {
            method: "get";
            url: "/rest/subscriptions/organisations";
        };
    };
    /** @summary Freezes an organisation, making it read-only. (Authorised Roles: ProjectAdministrator, PlatformAdministrator, SuperUser) */
    postSubscriptionsApiFreezeOrganisation: {
        schema: {
            method: "post";
            url: "/rest/subscriptions/organisation/freeze";
            mediaType: "application/json-patch+json";
        };
    };
    /** @summary Return user (Authorised Roles: ProjectAdministrator, PlatformAdministrator, SuperUser) */
    getSubscriptionsApiGetOrganisationUser: {
        schema: {
            method: "get";
            url: "/rest/subscriptions/organisation/user";
        };
    };
    /** @summary Lists all users in an organisation. (Authorised Roles: ProjectAdministrator, ProjectLeader, PlatformAdministrator, SuperUser) */
    getSubscriptionsApiListOrganisationUsers: {
        schema: {
            method: "get";
            url: "/rest/subscriptions/organisation/users";
        };
    };
    /** @summary Adds a new user to an organisation. (Authorised Roles: ProjectAdministrator, ProjectLeader, PlatformAdministrator, SuperUser) */
    putSubscriptionsApiAddUser: {
        schema: {
            method: "put";
            url: "/rest/subscriptions/organisation/users";
            mediaType: "application/json-patch+json";
        };
    };
    /** @summary Updates an existing user within an organisation. (Authorised Roles: ProjectAdministrator, ProjectLeader, PlatformAdministrator, SuperUser) */
    postSubscriptionsApiUpdateUser: {
        schema: {
            method: "post";
            url: "/rest/subscriptions/organisation/users";
            mediaType: "application/json-patch+json";
        };
    };
    /** @summary Deletes a user from an organisation. (Authorised Roles: ProjectAdministrator, ProjectLeader, PlatformAdministrator, SuperUser) */
    deleteSubscriptionsApiDeleteUser: {
        schema: {
            method: "delete";
            url: "/rest/subscriptions/organisation/users";
        };
    };
    /** @summary Lists platform admins assigned to an organisation (Authorised Roles: ProjectAdministrator, ProjectLeader, PlatformAdministrator, SuperUser) */
    getSubscriptionsApiListOrganisationPlatformAdmins: {
        schema: {
            method: "get";
            url: "/rest/subscriptions/organisations/admins";
        };
    };
    /** @summary Assign a platform admin user to an organisation (Authorised Roles: SuperUser) */
    putSubscriptionsApiAddPlatformAdmin: {
        schema: {
            method: "put";
            url: "/rest/subscriptions/organisations/admins";
        };
    };
    /** @summary Unassign at platform admin from an organisation (Authorised Roles: SuperUser) */
    deleteSubscriptionsApiRemovePlatformAdmin: {
        schema: {
            method: "delete";
            url: "/rest/subscriptions/organisations/admins";
        };
    };
    /** @summary Lists all available platform admins (based on role) (Authorised Roles: SuperUser) */
    getSubscriptionsApiListAllPlatformAdmins: {
        schema: {
            method: "get";
            url: "/rest/subscriptions/organisations/admins/all";
        };
    };
    /** @summary Freezes a user, making their account read-only. (Authorised Roles: ProjectAdministrator, ProjectLeader, PlatformAdministrator, SuperUser) */
    postSubscriptionsApiFreezeUser: {
        schema: {
            method: "post";
            url: "/rest/subscriptions/organisation/users/freeze";
        };
    };
    /** @summary Unfreezes a user, making their account active (Authorised Roles: PlatformAdministrator, SuperUser) */
    postSubscriptionsApiUnfreezeUser: {
        schema: {
            method: "post";
            url: "/rest/subscriptions/organisation/users/unfreeze";
        };
    };
    /** @summary Retrieves data for a specified project team (Authorised Roles: ProjectAdministrator, ProjectLeader, PlatformAdministrator, SuperUser) */
    getSubscriptionsApiGetOrganisationProjectTeam: {
        schema: {
            method: "get";
            url: "/rest/subscriptions/organisations/teams/{teamId}";
        };
    };
    /** @summary Retrieves the list of organisation project teams. (Authorised Roles: ProjectAdministrator, ProjectLeader, PlatformAdministrator, SuperUser) */
    getSubscriptionsApiGetOrganisationTeams: {
        schema: {
            method: "get";
            url: "/rest/subscriptions/organisations/teams";
        };
    };
    /** @summary Adds a new project team to the organisation. (Authorised Roles: ProjectLeader, PlatformAdministrator, SuperUser) */
    putSubscriptionsApiAddTeam: {
        schema: {
            method: "put";
            url: "/rest/subscriptions/organisation/teams";
            mediaType: "application/json-patch+json";
        };
    };
    /** @summary Updates a project team (Authorised Roles: ProjectLeader, PlatformAdministrator, SuperUser) */
    postSubscriptionsApiUpdateTeam: {
        schema: {
            method: "post";
            url: "/rest/subscriptions/organisation/teams";
            mediaType: "application/json-patch+json";
        };
    };
    /** @summary Freezes a team (Authorised Roles: ProjectLeader, PlatformAdministrator, SuperUser) */
    postSubscriptionsApiFreezeTeam: {
        schema: {
            method: "post";
            url: "/rest/subscriptions/organisation/teams/freeze";
        };
    };
    /** @summary  (Authorised Roles: ProjectAdministrator, ProjectLeader, PlatformAdministrator, SuperUser, ApplicationAdministrator) */
    getSubscriptionsApiListTeamUsers: {
        schema: {
            method: "get";
            url: "/rest/subscriptions/organisation/teams/users";
        };
    };
    /** @summary  (Authorised Roles: ProjectAdministrator, ProjectLeader, PlatformAdministrator, SuperUser) */
    postSubscriptionsApiAddTeamUser: {
        schema: {
            method: "post";
            url: "/rest/subscriptions/organisation/teams/users";
            mediaType: "application/json-patch+json";
        };
    };
    /** @summary  (Authorised Roles: PlatformAdministrator, SuperUser) */
    deleteSubscriptionsApiDeleteTeamUser: {
        schema: {
            method: "delete";
            url: "/rest/subscriptions/organisation/teams/users";
            mediaType: "application/json-patch+json";
        };
    };
    /** @summary  (Authorised Roles: ProjectAdministrator, ProjectLeader, PlatformAdministrator, SuperUser, ApplicationAdministrator) */
    getSubscriptionsApiListTeamRoles: {
        schema: {
            method: "get";
            url: "/rest/subscriptions/organisation/teams/roles";
        };
    };
    /** @summary  (Authorised Roles: ProjectAdministrator, ProjectLeader, PlatformAdministrator, SuperUser) */
    putSubscriptionsApiAddTeamRole: {
        schema: {
            method: "put";
            url: "/rest/subscriptions/organisation/teams/roles";
            mediaType: "application/json-patch+json";
        };
    };
    /** @summary  (Authorised Roles: PlatformAdministrator, SuperUser) */
    deleteSubscriptionsApiDeleteTeamRole: {
        schema: {
            method: "delete";
            url: "/rest/subscriptions/organisation/teams/roles";
            mediaType: "application/json-patch+json";
        };
    };
    /** @summary  (Authorised Roles: ProjectAdministrator, ProjectLeader, PlatformAdministrator, SuperUser) */
    getSubscriptionsApiGetOrganisationWorkspaces: {
        schema: {
            method: "get";
            url: "/rest/subscriptions/organisations/workspaces";
        };
    };
    /** @summary  (Authorised Roles: ProjectLeader, PlatformAdministrator, SuperUser) */
    putSubscriptionsApiAddOrganisationWorkspaces: {
        schema: {
            method: "put";
            url: "/rest/subscriptions/organisations/workspaces";
            mediaType: "application/json-patch+json";
        };
    };
    /** @summary  (Authorised Roles: ProjectLeader, PlatformAdministrator, SuperUser) */
    deleteSubscriptionsApiDeleteOrganisationWorkspaces: {
        schema: {
            method: "delete";
            url: "/rest/subscriptions/organisations/workspaces";
            mediaType: "application/json-patch+json";
        };
    };
    /** @summary  (Authorised Roles: ProjectAdministrator, ProjectLeader, PlatformAdministrator, SuperUser) */
    getSubscriptionsApiGetOrganisationWorkspace: {
        schema: {
            method: "get";
            url: "/rest/subscriptions/organisations/workspace";
        };
    };
    /** @summary  (Authorised Roles: ProjectAdministrator, ProjectLeader, PlatformAdministrator, SuperUser) */
    getSubscriptionsApiGetOrganisationWorkspacesSummary: {
        schema: {
            method: "get";
            url: "/rest/subscriptions/organisations/workspaces-summary";
        };
    };
    /** @summary flush the redis cache (Authorised Roles: SuperUser) */
    getSupportApiFlushRedis: {
        schema: {
            method: "get";
            url: "/rest/support/flush-redis";
        };
    };
    /** @summary set an arbitrary redis key/value (Authorised Roles: SuperUser) */
    getSupportApiSetRedis: {
        schema: {
            method: "get";
            url: "/rest/support/set-redis";
        };
    };
    /** @summary  (Authorised Roles: SuperUser) */
    getSupportApiListImages: {
        schema: {
            method: "get";
            url: "/rest/support/listImages";
        };
    };
    /** @summary  (Authorised Roles: SuperUser) */
    postSupportApiAddImage: {
        schema: {
            method: "post";
            url: "/rest/support/addImage";
            mediaType: "multipart/form-data";
        };
    };
    getSupportApiGetImage: {
        schema: {
            method: "get";
            url: "/rest/support/getImage";
        };
    };
    /** @summary  (Authorised Roles: SuperUser) */
    deleteSupportApiDeleteImage: {
        schema: {
            method: "delete";
            url: "/rest/support/deleteImage";
        };
    };
    /** @summary List file templates for an application / entity type (Authorised Roles: SuperUser, ApplicationAdministrator) */
    getTemplatesApiListFileTemplates: {
        schema: {
            method: "get";
            url: "/rest/templates";
        };
    };
    /** @summary Adds a new template. (Authorised Roles: SuperUser, ApplicationAdministrator) */
    putTemplatesApiAddTemplate: {
        schema: {
            method: "put";
            url: "/rest/templates";
            mediaType: "application/json-patch+json";
        };
    };
    /** @summary Updates a template. (Authorised Roles: SuperUser, ApplicationAdministrator) */
    postTemplatesApiUpdateTemplate: {
        schema: {
            method: "post";
            url: "/rest/templates";
            mediaType: "application/json-patch+json";
        };
    };
    /** @summary Deletes a template. (Authorised Roles: SuperUser, ApplicationAdministrator) */
    deleteTemplatesApiDeleteTemplate: {
        schema: {
            method: "delete";
            url: "/rest/templates";
            mediaType: "application/json-patch+json";
        };
    };
    getTemplatesApiGetTemplateSummary: {
        schema: {
            method: "get";
            url: "/rest/templates_summary/{applicationId},{projectId}";
        };
    };
    getTemplatesApiGetSpecificTemplateSummary: {
        schema: {
            method: "get";
            url: "/rest/templates_activity_log/{applicationId},{projectId},{entityId},{templateId}";
        };
    };
    postTemplatesApiPostTransitionUpdate: {
        schema: {
            method: "post";
            url: "/rest/templates_activity_log_transition_template";
            mediaType: "multipart/form-data";
        };
    };
    /** @summary Get a menu for the app/user */
    getUiApiGetSupportMenu: {
        schema: {
            method: "get";
            url: "/rest/ui/support-menu";
        };
    };
    /** @summary Get pages of an app */
    getUiApiGetPages: {
        schema: {
            method: "get";
            url: "/rest/ui/pages/{applicationId}";
        };
    };
    /** @summary Get roles of an app */
    getUiApiGetRoles: {
        schema: {
            method: "get";
            url: "/rest/ui/roles/{applicationId}";
        };
    };
    /** @summary Gets the config menu of an app */
    getUiApiGetMenu: {
        schema: {
            method: "get";
            url: "/rest/ui/menu/{applicationId}/{grouping}";
        };
    };
    /** @summary Updates the config menu of an app */
    postUiApiUpdateMenu: {
        schema: {
            method: "post";
            url: "/rest/ui/menu/{applicationId}/{grouping}";
            mediaType: "application/json-patch+json";
        };
    };
    /** @summary Gets the cascading filters */
    getUiApiGetFilterGroup: {
        schema: {
            method: "get";
            url: "/rest/ui/filter-group/{applicationId}/{projectId}/{filterGroup}";
        };
    };
    /** @summary Sets the cascading filters */
    postUiApiGetFilterGroup: {
        schema: {
            method: "post";
            url: "/rest/ui/filter-group/{applicationId}/{projectId}/{filterGroup}";
            mediaType: "application/json-patch+json";
        };
    };
    /** @summary Gets the applications related to a project */
    getUiApiGetApplicationsByProject: {
        schema: {
            method: "get";
            url: "/rest/ui/applications/{projectId}";
        };
    };
    /** @summary Retrieves list of assigned workspaces for current user (Authorised Roles: ProjectMember) */
    getWorkspacesApiGetCurrentUserWorkspaces: {
        schema: {
            method: "get";
            url: "/rest/workspaces/current";
        };
    };
    /** @summary Retrieves workspace on app key and project id (Authorised Roles: ProjectMember) */
    getWorkspacesApiGetWorkspace: {
        schema: {
            method: "get";
            url: "/rest/workspaces/{appKey}/{projectId}";
        };
    };
    /** @summary  (Authorised Roles: ProjectAdministrator, ProjectLeader, PlatformAdministrator, SuperUser) */
    getWorkspacesApiGetProjectTeamsWorkspace: {
        schema: {
            method: "get";
            url: "/rest/workspaces/projectTeam";
        };
    };
    /** @summary  (Authorised Roles: ProjectLeader, PlatformAdministrator, SuperUser) */
    putWorkspacesApiAddProjectTeamToWorkspace: {
        schema: {
            method: "put";
            url: "/rest/workspaces/projectTeam";
            mediaType: "application/json-patch+json";
        };
    };
    /** @summary  (Authorised Roles: ProjectLeader, PlatformAdministrator, SuperUser) */
    deleteWorkspacesApiDeleteProjectTeamFromWorkspace: {
        schema: {
            method: "delete";
            url: "/rest/workspaces/projectTeam";
            mediaType: "application/json-patch+json";
        };
    };
    /** @summary  (Authorised Roles: ProjectAdministrator, ProjectLeader, PlatformAdministrator, SuperUser) */
    getWorkspacesApiGetSupportTeamsWorkspace: {
        schema: {
            method: "get";
            url: "/rest/workspaces/supportTeam";
        };
    };
    /** @summary  (Authorised Roles: ProjectLeader, PlatformAdministrator, SuperUser) */
    putWorkspacesApiAddSupportTeamToWorkspace: {
        schema: {
            method: "put";
            url: "/rest/workspaces/supportTeam";
            mediaType: "application/json-patch+json";
        };
    };
    /** @summary  (Authorised Roles: ProjectLeader, PlatformAdministrator, SuperUser) */
    deleteWorkspacesApiDeleteSupportTeamFromWorkspace: {
        schema: {
            method: "delete";
            url: "/rest/workspaces/supportTeam";
            mediaType: "application/json-patch+json";
        };
    };
    /** @summary  (Authorised Roles: ProjectAdministrator, ProjectLeader, PlatformAdministrator, SuperUser) */
    getWorkspacesApiGetOrganisationWorkspaceEntities: {
        schema: {
            method: "get";
            url: "/rest/workspaces/entities";
        };
    };
    /** @summary  (Authorised Roles: ProjectAdministrator, ProjectLeader, PlatformAdministrator, SuperUser) */
    postWorkspacesApiUpdateEntity: {
        schema: {
            method: "post";
            url: "/rest/workspaces/entities";
            mediaType: "application/json-patch+json";
        };
    };
    /** @summary  (Authorised Roles: ProjectAdministrator, ProjectLeader, PlatformAdministrator, SuperUser) */
    deleteWorkspacesApiDeleteEntity: {
        schema: {
            method: "delete";
            url: "/rest/workspaces/entities";
        };
    };
    /** @summary  (Authorised Roles: ProjectAdministrator, ProjectLeader, PlatformAdministrator, SuperUser) */
    deleteWorkspacesApiDeleteEntityFiles: {
        schema: {
            method: "delete";
            url: "/rest/workspaces/entities/files";
        };
    };
    /** @summary  (Authorised Roles: ProjectAdministrator, ProjectLeader, PlatformAdministrator, SuperUser) */
    getWorkspacesApiGetUsers: {
        schema: {
            method: "get";
            url: "/rest/workspaces/users";
        };
    };
    /** @summary  (Authorised Roles: ProjectLeader, PlatformAdministrator, SuperUser) */
    getWorkspacesApiGetWorkspaceAuditDetails: {
        schema: {
            method: "get";
            url: "/rest/workspaces/{workspaceId}/audit";
        };
    };
    /** @summary  (Authorised Roles: ProjectAdministrator, ProjectLeader, PlatformAdministrator, SuperUser) */
    getWorkspacesApiGetWorkspaceUsers: {
        schema: {
            method: "get";
            url: "/rest/workspaces/{workspaceId}/users";
        };
    };
    /** @summary  (Authorised Roles: ProjectLeader, PlatformAdministrator, SuperUser) */
    getWorkspacesApiAddApprovedWorkspaceUsersAudit: {
        schema: {
            method: "get";
            url: "/rest/workspaces/workspaceUserAudits";
            mediaType: "application/json-patch+json";
        };
    };
    /** @summary  (Authorised Roles: ProjectLeader, PlatformAdministrator, SuperUser) */
    postWorkspacesApiAddApprovedWorkspaceUsersAudit: {
        schema: {
            method: "post";
            url: "/rest/workspaces/workspaceUserAudits";
            mediaType: "application/json-patch+json";
        };
    };
} = {
    postActivityLoggingApiLogLogin: {
        schema: {
            method: "post",
            url: "/rest/login"
        }
    },
    postActivityLoggingApiLogAppAccess: {
        schema: {
            method: "post",
            url: "/rest/app-access"
        }
    },
    getApplicationsApiGetApplications: {
        schema: {
            method: "get",
            url: "/rest/applications/list"
        }
    },
    putApplicationsApiAddApplication: {
        schema: {
            method: "put",
            url: "/rest/applications/application",
            mediaType: "application/json-patch+json"
        }
    },
    postApplicationsApiUpdateApplication: {
        schema: {
            method: "post",
            url: "/rest/applications/application",
            mediaType: "application/json-patch+json"
        }
    },
    getApplicationsApiListApplicationAdmins: {
        schema: {
            method: "get",
            url: "/rest/applications/admins"
        }
    },
    putApplicationsApiAddApplicationAdmin: {
        schema: {
            method: "put",
            url: "/rest/applications/admins"
        }
    },
    deleteApplicationsApiRemoveApplicationAdmin: {
        schema: {
            method: "delete",
            url: "/rest/applications/admins"
        }
    },
    getApplicationsApiListAllAdmins: {
        schema: {
            method: "get",
            url: "/rest/applications/admins/all"
        }
    },
    getApplicationsApiListApplicationRoles: {
        schema: {
            method: "get",
            url: "/rest/applications/roles"
        }
    },
    putApplicationsApiAddApplicationRole: {
        schema: {
            method: "put",
            url: "/rest/applications/roles",
            mediaType: "application/json-patch+json"
        }
    },
    postApplicationsApiUpdateApplicationRole: {
        schema: {
            method: "post",
            url: "/rest/applications/roles",
            mediaType: "application/json-patch+json"
        }
    },
    getApplicationsApiGetApplicationAttributes: {
        schema: {
            method: "get",
            url: "/rest/applications/attribs"
        }
    },
    postApplicationsApiUpdateApplicationAttributes: {
        schema: {
            method: "post",
            url: "/rest/applications/attribs",
            mediaType: "application/json-patch+json"
        }
    },
    getApplicationsApiGetApplicationTeamsForUserOrganization: {
        schema: {
            method: "get",
            url: "/rest/applications/teams/{appId}"
        }
    },
    getApplicationsApiGetApplicationTeams: {
        schema: {
            method: "get",
            url: "/rest/applications/teams"
        }
    },
    getApplicationsApiGetApplicationSupportTeamUsersForOrg: {
        schema: {
            method: "get",
            url: "/rest/applications/teams/support/{appId}"
        }
    },
    putApplicationsApiAddTeam: {
        schema: {
            method: "put",
            url: "/rest/applications/teams/support",
            mediaType: "application/json-patch+json"
        }
    },
    postApplicationsApiUpdateTeam: {
        schema: {
            method: "post",
            url: "/rest/applications/teams/support",
            mediaType: "application/json-patch+json"
        }
    },
    getApplicationsApiGetPictograms: {
        schema: {
            method: "get",
            url: "/rest/applications/pictograms"
        }
    },
    getApplicationsApiGetUsers: {
        schema: {
            method: "get",
            url: "/rest/applications/users"
        }
    },
    getApplicationsApiGetAccesses: {
        schema: {
            method: "get",
            url: "/rest/applications/accesses"
        }
    },
    postApplicationsApiSetAccesses: {
        schema: {
            method: "post",
            url: "/rest/applications/accesses",
            mediaType: "application/json-patch+json"
        }
    },
    getApplicationsApiGetEntityTypes: {
        schema: {
            method: "get",
            url: "/rest/applications/entityTypes"
        }
    },
    putApplicationsApiAddDataAssetPermission: {
        schema: {
            method: "put",
            url: "/rest/applications/data-assets",
            mediaType: "application/json-patch+json"
        }
    },
    postApplicationsApiUpdateDataAssetPermission: {
        schema: {
            method: "post",
            url: "/rest/applications/data-assets",
            mediaType: "application/json-patch+json"
        }
    },
    deleteApplicationsApiDeleteDataAssetPermission: {
        schema: {
            method: "delete",
            url: "/rest/applications/data-assets"
        }
    },
    putApplicationsApiAddFileTemplateRole: {
        schema: {
            method: "put",
            url: "/rest/applications/file-templates",
            mediaType: "application/json-patch+json"
        }
    },
    postApplicationsApiUpdateFileTemplateRole: {
        schema: {
            method: "post",
            url: "/rest/applications/file-templates",
            mediaType: "application/json-patch+json"
        }
    },
    deleteApplicationsApiDeleteFileTemplateRole: {
        schema: {
            method: "delete",
            url: "/rest/applications/file-templates"
        }
    },
    getApplicationsApiGetRolePermissions: {
        schema: {
            method: "get",
            url: "/rest/applications/roles/permissions"
        }
    },
    getAppSettingsApiGetAppSettings: {
        schema: {
            method: "get",
            url: "/rest/app-settings/{applicationId}"
        }
    },
    getAppSettingsApiGetAppSettingsDownloadFile: {
        schema: {
            method: "get",
            url: "/rest/app-settings/download/{applicationId}"
        }
    },
    postAppSettingsApiAppSettingsUpload: {
        schema: {
            method: "post",
            url: "/rest/app-settings/upload",
            mediaType: "multipart/form-data"
        }
    },
    getAppSettingsApiGetAppSettingsUploads: {
        schema: {
            method: "get",
            url: "/rest/app-settings-upload"
        }
    },
    getAppSettingsApiGetAppSettingsUpload: {
        schema: {
            method: "get",
            url: "/rest/app-settings-upload/{appSettingsUploadId}"
        }
    },
    patchAppSettingsApiGetAppSettingsUpload: {
        schema: {
            method: "patch",
            url: "/rest/app-settings-upload/{appSettingsUploadId}",
            mediaType: "application/json-patch+json"
        }
    },
    postAuthenticationApiGetToken: {
        schema: {
            method: "post",
            url: "/rest/getToken"
        }
    },
    postAuthenticationApiLogout: {
        schema: {
            method: "post",
            url: "/rest/logout"
        }
    },
    postAuthenticationApiLogoutUser: {
        schema: {
            method: "post",
            url: "/rest/logout/{userId}"
        }
    },
    postCatalogApiRegisterApplication: {
        schema: {
            method: "post",
            url: "/rest/catalog/register",
            mediaType: "application/json-patch+json"
        }
    },
    postCatalogApiContentHandler: {
        schema: {
            method: "post",
            url: "/rest/catalog/handler/content",
            mediaType: "application/json-patch+json"
        }
    },
    getChatApiGetChat: {
        schema: {
            method: "get",
            url: "/rest/chat/{applicationId}"
        }
    },
    putChatApiAddChat: {
        schema: {
            method: "put",
            url: "/rest/chat/{applicationId}",
            mediaType: "application/json-patch+json"
        }
    },
    postChatApiPostChat: {
        schema: {
            method: "post",
            url: "/rest/chat/{applicationId}",
            mediaType: "application/json-patch+json"
        }
    },
    getChatApiGetChatItem: {
        schema: {
            method: "get",
            url: "/rest/chat/{applicationId}/{chatId}"
        }
    },
    putDataAssetApiAddDataAsset: {
        schema: {
            method: "put",
            url: "/rest/data_asset",
            mediaType: "application/json-patch+json"
        }
    },
    postDataAssetApiUpdateTemplate: {
        schema: {
            method: "post",
            url: "/rest/data_asset",
            mediaType: "application/json-patch+json"
        }
    },
    deleteDataAssetApiDeleteTemplate: {
        schema: {
            method: "delete",
            url: "/rest/data_asset",
            mediaType: "application/json-patch+json"
        }
    },
    getDataAssetApiListDataAssets: {
        schema: {
            method: "get",
            url: "/rest/data_asset"
        }
    },
    getDataAssetApiGetTemplateSummary: {
        schema: {
            method: "get",
            url: "/rest/data_asset/summary/{applicationId},{projectId}"
        }
    },
    getDataAssetApiGetSpecificDataAssetSummary: {
        schema: {
            method: "get",
            url: "/rest/data_asset/activity_log/{applicationId},{projectId},{entityId},{dataAssetId}"
        }
    },
    postDataAssetApiPostTransitionUpdate: {
        schema: {
            method: "post",
            url: "/rest/data_asset/transition",
            mediaType: "multipart/form-data"
        }
    },
    getDatabricksApiGetDatabricksStatus: {
        schema: {
            method: "get",
            url: "/rest/databricks/connection"
        }
    },
    putDatabricksApiInitialiseDatabricks: {
        schema: {
            method: "put",
            url: "/rest/databricks/connection"
        }
    },
    getDatabricksApiGetDatabricksApplicationStatus: {
        schema: {
            method: "get",
            url: "/rest/databricks/application"
        }
    },
    putDatabricksApiProvisionApplication: {
        schema: {
            method: "put",
            url: "/rest/databricks/application"
        }
    },
    postDatabricksApiPromoteApplication: {
        schema: {
            method: "post",
            url: "/rest/databricks/application/promote"
        }
    },
    putDatabricksApiAddDefaultApplicationNotebook: {
        schema: {
            method: "put",
            url: "/rest/databricks/application/notebooks"
        }
    },
    postDatabricksApiAddApplicationNotebook: {
        schema: {
            method: "post",
            url: "/rest/databricks/application/notebooks",
            mediaType: "multipart/form-data"
        }
    },
    getDatabricksApiGetDatabricksWorkspaceStatus: {
        schema: {
            method: "get",
            url: "/rest/databricks/workspace"
        }
    },
    putDatabricksApiCreateDatabricksWorkspace: {
        schema: {
            method: "put",
            url: "/rest/databricks/workspace"
        }
    },
    putDatabricksApiSyncDatabricksWorkspaceJobs: {
        schema: {
            method: "put",
            url: "/rest/databricks/workspace/jobs/sync"
        }
    },
    putDatabricksApiRunDatabricksWorkspaceJobs: {
        schema: {
            method: "put",
            url: "/rest/databricks/workspace/jobs/run"
        }
    },
    getDatabricksApiGetDatabricksWorkspacePowerBi: {
        schema: {
            method: "get",
            url: "/rest/databricks/workspace/powerbi"
        }
    },
    postEntityTypeApiCreateEntityType: {
        schema: {
            method: "post",
            url: "/rest/entitytypes/entityType",
            mediaType: "application/json-patch+json"
        }
    },
    putEntityTypeApiUpdateEntityType: {
        schema: {
            method: "put",
            url: "/rest/entitytypes/entityType",
            mediaType: "application/json-patch+json"
        }
    },
    getEntityTypeApiGetEntityTypesByApplicationId: {
        schema: {
            method: "get",
            url: "/rest/entitytypes/application/{applicationId}"
        }
    },
    deleteEntityTypeApiDeleteEntityType: {
        schema: {
            method: "delete",
            url: "/rest/entitytypes/{id}"
        }
    },
    getFaqApiGetFaq: {
        schema: {
            method: "get",
            url: "/rest/faq/{applicationId}"
        }
    },
    putFaqApiAddFaq: {
        schema: {
            method: "put",
            url: "/rest/faq/{applicationId}",
            mediaType: "application/json-patch+json"
        }
    },
    postFaqApiPostFaq: {
        schema: {
            method: "post",
            url: "/rest/faq/{applicationId}",
            mediaType: "application/json-patch+json"
        }
    },
    getFaqApiGetFaqItem: {
        schema: {
            method: "get",
            url: "/rest/faq/{applicationId}/{questionId}"
        }
    },
    patchFaqApiUpdateFaqItem: {
        schema: {
            method: "patch",
            url: "/rest/faq/{applicationId}/{questionId}",
            mediaType: "application/json-patch+json"
        }
    },
    deleteFaqApiDeleteFaqItem: {
        schema: {
            method: "delete",
            url: "/rest/faq/{applicationId}/{questionId}"
        }
    },
    getGlossaryApiGetGlossary: {
        schema: {
            method: "get",
            url: "/rest/glossary/{applicationId}"
        }
    },
    putGlossaryApiAddGlossary: {
        schema: {
            method: "put",
            url: "/rest/glossary/{applicationId}",
            mediaType: "application/json-patch+json"
        }
    },
    postGlossaryApiPostGlossary: {
        schema: {
            method: "post",
            url: "/rest/glossary/{applicationId}",
            mediaType: "application/json-patch+json"
        }
    },
    getGlossaryApiGetGlossaryItem: {
        schema: {
            method: "get",
            url: "/rest/glossary/{applicationId}/{termId}"
        }
    },
    patchGlossaryApiUpdateGlossaryItem: {
        schema: {
            method: "patch",
            url: "/rest/glossary/{applicationId}/{termId}",
            mediaType: "application/json-patch+json"
        }
    },
    deleteGlossaryApiDeleteGlossaryItem: {
        schema: {
            method: "delete",
            url: "/rest/glossary/{applicationId}/{termId}"
        }
    },
    getLandingApiGetApplicationExternal: {
        schema: {
            method: "get",
            url: "/rest/application_external"
        }
    },
    getLandingApiGetApplicationInfoExternal: {
        schema: {
            method: "get",
            url: "/rest/application_info_external/{applicationId}"
        }
    },
    getLandingApiGetPlatformExternal: {
        schema: {
            method: "get",
            url: "/rest/platform_external"
        }
    },
    getLandingApiGetApplicationProjects: {
        schema: {
            method: "get",
            url: "/rest/application_projects"
        }
    },
    getLandingApiGetProjects: {
        schema: {
            method: "get",
            url: "/rest/projects"
        }
    },
    getLandingApiGetApplications: {
        schema: {
            method: "get",
            url: "/rest/applications"
        }
    },
    getLandingApiGetPlatformOperations: {
        schema: {
            method: "get",
            url: "/rest/platform"
        }
    },
    getPipelineApiGetPipeline: {
        schema: {
            method: "get",
            url: "/rest/pipeline/{applicationId}"
        }
    },
    putPipelineApiAddPipeline: {
        schema: {
            method: "put",
            url: "/rest/pipeline/{applicationId}",
            mediaType: "application/json-patch+json"
        }
    },
    postPipelineApiPostPipeline: {
        schema: {
            method: "post",
            url: "/rest/pipeline/{applicationId}",
            mediaType: "application/json-patch+json"
        }
    },
    getPipelineApiGetPipelineItem: {
        schema: {
            method: "get",
            url: "/rest/pipeline/{applicationId}/{pipelineId}"
        }
    },
    getProjectsApiGetUsers: {
        schema: {
            method: "get",
            url: "/rest/projects/users"
        }
    },
    putProjectsApiAddUserToProject: {
        schema: {
            method: "put",
            url: "/rest/projects/users",
            mediaType: "application/json-patch+json"
        }
    },
    deleteProjectsApiRemoveUserFromProject: {
        schema: {
            method: "delete",
            url: "/rest/projects/users",
            mediaType: "application/json-patch+json"
        }
    },
    putProjectsApiUpdateUserFromProject: {
        schema: {
            method: "put",
            url: "/rest/projects/users/update",
            mediaType: "application/json-patch+json"
        }
    },
    getProjectsApiListOrganisationProjects: {
        schema: {
            method: "get",
            url: "/rest/projects/organisation/projects"
        }
    },
    putProjectsApiAddProject: {
        schema: {
            method: "put",
            url: "/rest/projects/organisation/projects",
            mediaType: "application/json-patch+json"
        }
    },
    postProjectsApiUpdateProject: {
        schema: {
            method: "post",
            url: "/rest/projects/organisation/projects",
            mediaType: "application/json-patch+json"
        }
    },
    postProjectsApiFreezeProject: {
        schema: {
            method: "post",
            url: "/rest/projects/organisation/projects/freeze",
            mediaType: "application/json-patch+json"
        }
    },
    postProjectsApiUnfreezeProject: {
        schema: {
            method: "post",
            url: "/rest/projects/organisation/projects/unfreeze",
            mediaType: "application/json-patch+json"
        }
    },
    putProjectsApiAddProjectAdmin: {
        schema: {
            method: "put",
            url: "/rest/projects/organisation/projects/admins"
        }
    },
    deleteProjectsApiRemoveProjectAdmin: {
        schema: {
            method: "delete",
            url: "/rest/projects/organisation/projects/admins"
        }
    },
    putProjectsApiAddProjectLeader: {
        schema: {
            method: "put",
            url: "/rest/projects/organisation/projects/leaders"
        }
    },
    deleteProjectsApiRemoveProjectLeader: {
        schema: {
            method: "delete",
            url: "/rest/projects/organisation/projects/leaders"
        }
    },
    postStorageApiStorageFileRequirements: {
        schema: {
            method: "post",
            url: "/rest/storage/fileRequirements"
        }
    },
    postStorageApiUploadFile: {
        schema: {
            method: "post",
            url: "/rest/storage/upload_file",
            mediaType: "multipart/form-data"
        }
    },
    getStorageApiDownloadFile: {
        schema: {
            method: "get",
            url: "/rest/storage/download_file/{blobName},{applicationId},{projectId},{fileType}"
        }
    },
    getStorageApiDownloadFileWorkspace: {
        schema: {
            method: "get",
            url: "/rest/storage/download_file/workspace"
        }
    },
    getStorageApiGetFilesSummary: {
        schema: {
            method: "get",
            url: "/rest/storage/summary/{applicationId},{projectId}"
        }
    },
    getStorageApiGetFilesDetails: {
        schema: {
            method: "get",
            url: "/rest/storage/details/{applicationId},{projectId},{type}"
        }
    },
    getStorageApiGetFilesDetailsWorkspace: {
        schema: {
            method: "get",
            url: "/rest/storage/details/workspace"
        }
    },
    getStorageApiGetFilesDetailsEntityTemplates: {
        schema: {
            method: "get",
            url: "/rest/storage/details/entityTemplates"
        }
    },
    getStorageApiGetFilesDetailsEntityDataAssets: {
        schema: {
            method: "get",
            url: "/rest/storage/details/entityDataAssets"
        }
    },
    getStorageApiDeleteAll: {
        schema: {
            method: "get",
            url: "/rest/storage/delete-all/{applicationId},{projectId},{type}"
        }
    },
    getStorageApiDeleteUnused: {
        schema: {
            method: "get",
            url: "/rest/storage/delete-unused/{applicationId},{projectId},{type}"
        }
    },
    postStorageApiDeleteFileWorkspace: {
        schema: {
            method: "post",
            url: "/rest/storage/delete_file/workspace"
        }
    },
    getStorageApiMigrate: {
        schema: {
            method: "get",
            url: "/rest/storage/migrate/{applicationId},{projectId},{apply}"
        }
    },
    getStorageApiGetMigrationJob: {
        schema: {
            method: "get",
            url: "/rest/storage/migrate/{applicationId},{projectId},{jobId}"
        }
    },
    getSubscriptionsApiGetOrganisation: {
        schema: {
            method: "get",
            url: "/rest/subscriptions/organisation"
        }
    },
    putSubscriptionsApiAddOrganisation: {
        schema: {
            method: "put",
            url: "/rest/subscriptions/organisation",
            mediaType: "application/json-patch+json"
        }
    },
    postSubscriptionsApiUpdateOrganisation: {
        schema: {
            method: "post",
            url: "/rest/subscriptions/organisation",
            mediaType: "application/json-patch+json"
        }
    },
    getSubscriptionsApiGetOrganisations: {
        schema: {
            method: "get",
            url: "/rest/subscriptions/organisations"
        }
    },
    postSubscriptionsApiFreezeOrganisation: {
        schema: {
            method: "post",
            url: "/rest/subscriptions/organisation/freeze",
            mediaType: "application/json-patch+json"
        }
    },
    getSubscriptionsApiGetOrganisationUser: {
        schema: {
            method: "get",
            url: "/rest/subscriptions/organisation/user"
        }
    },
    getSubscriptionsApiListOrganisationUsers: {
        schema: {
            method: "get",
            url: "/rest/subscriptions/organisation/users"
        }
    },
    putSubscriptionsApiAddUser: {
        schema: {
            method: "put",
            url: "/rest/subscriptions/organisation/users",
            mediaType: "application/json-patch+json"
        }
    },
    postSubscriptionsApiUpdateUser: {
        schema: {
            method: "post",
            url: "/rest/subscriptions/organisation/users",
            mediaType: "application/json-patch+json"
        }
    },
    deleteSubscriptionsApiDeleteUser: {
        schema: {
            method: "delete",
            url: "/rest/subscriptions/organisation/users"
        }
    },
    getSubscriptionsApiListOrganisationPlatformAdmins: {
        schema: {
            method: "get",
            url: "/rest/subscriptions/organisations/admins"
        }
    },
    putSubscriptionsApiAddPlatformAdmin: {
        schema: {
            method: "put",
            url: "/rest/subscriptions/organisations/admins"
        }
    },
    deleteSubscriptionsApiRemovePlatformAdmin: {
        schema: {
            method: "delete",
            url: "/rest/subscriptions/organisations/admins"
        }
    },
    getSubscriptionsApiListAllPlatformAdmins: {
        schema: {
            method: "get",
            url: "/rest/subscriptions/organisations/admins/all"
        }
    },
    postSubscriptionsApiFreezeUser: {
        schema: {
            method: "post",
            url: "/rest/subscriptions/organisation/users/freeze"
        }
    },
    postSubscriptionsApiUnfreezeUser: {
        schema: {
            method: "post",
            url: "/rest/subscriptions/organisation/users/unfreeze"
        }
    },
    getSubscriptionsApiGetOrganisationProjectTeam: {
        schema: {
            method: "get",
            url: "/rest/subscriptions/organisations/teams/{teamId}"
        }
    },
    getSubscriptionsApiGetOrganisationTeams: {
        schema: {
            method: "get",
            url: "/rest/subscriptions/organisations/teams"
        }
    },
    putSubscriptionsApiAddTeam: {
        schema: {
            method: "put",
            url: "/rest/subscriptions/organisation/teams",
            mediaType: "application/json-patch+json"
        }
    },
    postSubscriptionsApiUpdateTeam: {
        schema: {
            method: "post",
            url: "/rest/subscriptions/organisation/teams",
            mediaType: "application/json-patch+json"
        }
    },
    postSubscriptionsApiFreezeTeam: {
        schema: {
            method: "post",
            url: "/rest/subscriptions/organisation/teams/freeze"
        }
    },
    getSubscriptionsApiListTeamUsers: {
        schema: {
            method: "get",
            url: "/rest/subscriptions/organisation/teams/users"
        }
    },
    postSubscriptionsApiAddTeamUser: {
        schema: {
            method: "post",
            url: "/rest/subscriptions/organisation/teams/users",
            mediaType: "application/json-patch+json"
        }
    },
    deleteSubscriptionsApiDeleteTeamUser: {
        schema: {
            method: "delete",
            url: "/rest/subscriptions/organisation/teams/users",
            mediaType: "application/json-patch+json"
        }
    },
    getSubscriptionsApiListTeamRoles: {
        schema: {
            method: "get",
            url: "/rest/subscriptions/organisation/teams/roles"
        }
    },
    putSubscriptionsApiAddTeamRole: {
        schema: {
            method: "put",
            url: "/rest/subscriptions/organisation/teams/roles",
            mediaType: "application/json-patch+json"
        }
    },
    deleteSubscriptionsApiDeleteTeamRole: {
        schema: {
            method: "delete",
            url: "/rest/subscriptions/organisation/teams/roles",
            mediaType: "application/json-patch+json"
        }
    },
    getSubscriptionsApiGetOrganisationWorkspaces: {
        schema: {
            method: "get",
            url: "/rest/subscriptions/organisations/workspaces"
        }
    },
    putSubscriptionsApiAddOrganisationWorkspaces: {
        schema: {
            method: "put",
            url: "/rest/subscriptions/organisations/workspaces",
            mediaType: "application/json-patch+json"
        }
    },
    deleteSubscriptionsApiDeleteOrganisationWorkspaces: {
        schema: {
            method: "delete",
            url: "/rest/subscriptions/organisations/workspaces",
            mediaType: "application/json-patch+json"
        }
    },
    getSubscriptionsApiGetOrganisationWorkspace: {
        schema: {
            method: "get",
            url: "/rest/subscriptions/organisations/workspace"
        }
    },
    getSubscriptionsApiGetOrganisationWorkspacesSummary: {
        schema: {
            method: "get",
            url: "/rest/subscriptions/organisations/workspaces-summary"
        }
    },
    getSupportApiFlushRedis: {
        schema: {
            method: "get",
            url: "/rest/support/flush-redis"
        }
    },
    getSupportApiSetRedis: {
        schema: {
            method: "get",
            url: "/rest/support/set-redis"
        }
    },
    getSupportApiListImages: {
        schema: {
            method: "get",
            url: "/rest/support/listImages"
        }
    },
    postSupportApiAddImage: {
        schema: {
            method: "post",
            url: "/rest/support/addImage",
            mediaType: "multipart/form-data"
        }
    },
    getSupportApiGetImage: {
        schema: {
            method: "get",
            url: "/rest/support/getImage"
        }
    },
    deleteSupportApiDeleteImage: {
        schema: {
            method: "delete",
            url: "/rest/support/deleteImage"
        }
    },
    getTemplatesApiListFileTemplates: {
        schema: {
            method: "get",
            url: "/rest/templates"
        }
    },
    putTemplatesApiAddTemplate: {
        schema: {
            method: "put",
            url: "/rest/templates",
            mediaType: "application/json-patch+json"
        }
    },
    postTemplatesApiUpdateTemplate: {
        schema: {
            method: "post",
            url: "/rest/templates",
            mediaType: "application/json-patch+json"
        }
    },
    deleteTemplatesApiDeleteTemplate: {
        schema: {
            method: "delete",
            url: "/rest/templates",
            mediaType: "application/json-patch+json"
        }
    },
    getTemplatesApiGetTemplateSummary: {
        schema: {
            method: "get",
            url: "/rest/templates_summary/{applicationId},{projectId}"
        }
    },
    getTemplatesApiGetSpecificTemplateSummary: {
        schema: {
            method: "get",
            url: "/rest/templates_activity_log/{applicationId},{projectId},{entityId},{templateId}"
        }
    },
    postTemplatesApiPostTransitionUpdate: {
        schema: {
            method: "post",
            url: "/rest/templates_activity_log_transition_template",
            mediaType: "multipart/form-data"
        }
    },
    getUiApiGetSupportMenu: {
        schema: {
            method: "get",
            url: "/rest/ui/support-menu"
        }
    },
    getUiApiGetPages: {
        schema: {
            method: "get",
            url: "/rest/ui/pages/{applicationId}"
        }
    },
    getUiApiGetRoles: {
        schema: {
            method: "get",
            url: "/rest/ui/roles/{applicationId}"
        }
    },
    getUiApiGetMenu: {
        schema: {
            method: "get",
            url: "/rest/ui/menu/{applicationId}/{grouping}"
        }
    },
    postUiApiUpdateMenu: {
        schema: {
            method: "post",
            url: "/rest/ui/menu/{applicationId}/{grouping}",
            mediaType: "application/json-patch+json"
        }
    },
    getUiApiGetFilterGroup: {
        schema: {
            method: "get",
            url: "/rest/ui/filter-group/{applicationId}/{projectId}/{filterGroup}"
        }
    },
    postUiApiGetFilterGroup: {
        schema: {
            method: "post",
            url: "/rest/ui/filter-group/{applicationId}/{projectId}/{filterGroup}",
            mediaType: "application/json-patch+json"
        }
    },
    getUiApiGetApplicationsByProject: {
        schema: {
            method: "get",
            url: "/rest/ui/applications/{projectId}"
        }
    },
    getWorkspacesApiGetCurrentUserWorkspaces: {
        schema: {
            method: "get",
            url: "/rest/workspaces/current"
        }
    },
    getWorkspacesApiGetWorkspace: {
        schema: {
            method: "get",
            url: "/rest/workspaces/{appKey}/{projectId}"
        }
    },
    getWorkspacesApiGetProjectTeamsWorkspace: {
        schema: {
            method: "get",
            url: "/rest/workspaces/projectTeam"
        }
    },
    putWorkspacesApiAddProjectTeamToWorkspace: {
        schema: {
            method: "put",
            url: "/rest/workspaces/projectTeam",
            mediaType: "application/json-patch+json"
        }
    },
    deleteWorkspacesApiDeleteProjectTeamFromWorkspace: {
        schema: {
            method: "delete",
            url: "/rest/workspaces/projectTeam",
            mediaType: "application/json-patch+json"
        }
    },
    getWorkspacesApiGetSupportTeamsWorkspace: {
        schema: {
            method: "get",
            url: "/rest/workspaces/supportTeam"
        }
    },
    putWorkspacesApiAddSupportTeamToWorkspace: {
        schema: {
            method: "put",
            url: "/rest/workspaces/supportTeam",
            mediaType: "application/json-patch+json"
        }
    },
    deleteWorkspacesApiDeleteSupportTeamFromWorkspace: {
        schema: {
            method: "delete",
            url: "/rest/workspaces/supportTeam",
            mediaType: "application/json-patch+json"
        }
    },
    getWorkspacesApiGetOrganisationWorkspaceEntities: {
        schema: {
            method: "get",
            url: "/rest/workspaces/entities"
        }
    },
    postWorkspacesApiUpdateEntity: {
        schema: {
            method: "post",
            url: "/rest/workspaces/entities",
            mediaType: "application/json-patch+json"
        }
    },
    deleteWorkspacesApiDeleteEntity: {
        schema: {
            method: "delete",
            url: "/rest/workspaces/entities"
        }
    },
    deleteWorkspacesApiDeleteEntityFiles: {
        schema: {
            method: "delete",
            url: "/rest/workspaces/entities/files"
        }
    },
    getWorkspacesApiGetUsers: {
        schema: {
            method: "get",
            url: "/rest/workspaces/users"
        }
    },
    getWorkspacesApiGetWorkspaceAuditDetails: {
        schema: {
            method: "get",
            url: "/rest/workspaces/{workspaceId}/audit"
        }
    },
    getWorkspacesApiGetWorkspaceUsers: {
        schema: {
            method: "get",
            url: "/rest/workspaces/{workspaceId}/users"
        }
    },
    getWorkspacesApiAddApprovedWorkspaceUsersAudit: {
        schema: {
            method: "get",
            url: "/rest/workspaces/workspaceUserAudits",
            mediaType: "application/json-patch+json"
        }
    },
    postWorkspacesApiAddApprovedWorkspaceUsersAudit: {
        schema: {
            method: "post",
            url: "/rest/workspaces/workspaceUserAudits",
            mediaType: "application/json-patch+json"
        }
    }
};
